import {
  setDisplay,
  showToast,
  copyText,
  setCookie,
  getCookie,
  formatMessageDate,
  disableButton,
  formatTime,
  getGenreList,
  getLangList,
  getCountryList,
  getCountryIndex,
  getCountryCode,
  reformatPaste,
  getRandomNum,
} from "./common";

import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/storage";
import phRadioImg from "url:../images/radio_placeholder.svg";
import phPerson from "url:../images/person.svg";
import phBanner from "url:../images/sound_wave.svg";
import phPodcast from "url:../images/podcast.svg";
import phCoins from "url:../images/ic_coins.svg";
import { prodApp, purchaseApp } from "./config";
const { podcastXmlParser } = require("podcast-xml-parser");
//const podcastFeedParser = require("@podverse/podcast-feed-parser");
const config = {
  requestSize: 100000, // Fetches enough bytes for plenty of recent content
  start: 0, // Start at the very first (most recent) episode
  limit: 10, // Restrict the parsed episodes array to exactly 10 items
};
var uid;
var uiName;
var nav;
var trans;
var btnToggleNav;
var mainNav = 0;
var vRadiosRef, uvRadiosRef, usersRef, userRef, vPodsRef, uvPodsRef;
var navs, navMeat, navTitles;
var navContent, radioContent, editContent, mainContent, userContent, podContent;
var imgLogo,
  imgBanner,
  inRadioName,
  radioAlert,
  inSlogan,
  inDesc,
  inStream,
  elAudio,
  pAudioAlert,
  inLocation,
  inEmail,
  inPhone,
  inWeb,
  btnGoStream,
  inTestUrl,
  lblTestUrl;
var inAdminName,
  pRequestDate,
  pRadioId,
  iRadioId,
  pAdminId,
  iAdminId,
  iRequestDate,
  inWebStream,
  inWelcome;
var btnRequestInfo,
  btnReject,
  btnApprove,
  btnUpdate,
  btnTestUrl,
  btnAddProduct,
  btnAddCoinPack;
var dWelcome, dTestStream;
var btnBack;
var iRadioInfo;
var iUser;
var xUid;
var xRadioId;
var xRadioAdmin;
var radioClass;
var podClass;
var iVerified;
var firstInit = true;
var isMainContent = true;
var iPodContent;
var xPodId;
var prodRef;
var wdRef, userWdRef, approvedWdRef, balanceRef;
var btnClearSearch, btnSearch;
var divResults,
  pResultLoader,
  pEmpty,
  spName,
  spNotFound,
  divSearchList,
  btnRadioRevision;
const SearchType = {
  sum: "SUM",
  radio: "RADIO",
  users: "USERS",
  pod: "PODCAST",
  purchase: "PURCHASE",
  wd: "WD",
};
var searchType, inSearch, updatingModal, btnGoWeb;
var fromSearch = false;
var progressModal, reviseRadios;

$(document).ready(function () {
  initViews();
  translatePage();
  initSelections();
  checkWindowWidth();
  checkUser();
  reformatPaste();
});

function initViews() {
  nav = document.getElementById("nav");
  btnToggleNav = document.getElementById("btnToggleNav");
  navs = navList.querySelectorAll("a");
  mainContent = document.getElementById("mainContent");
  navContent = document.getElementById("navContent");
  navMeat = mainContent.querySelectorAll(".meat");
  navTitles = navList.querySelectorAll("a .title");
  editContent = document.getElementById("editContent");
  radioContent = document.getElementById("radioContent");
  userContent = document.getElementById("userContent");
  podContent = document.getElementById("podContent");
  imgLogo = document.getElementById("imgRadioLogo");
  imgBanner = document.getElementById("imgRadioBanner");
  inRadioName = document.getElementById("inRadioName");
  inSlogan = document.getElementById("inSlogan");
  inStream = document.getElementById("inStream");
  inLocation = document.getElementById("inLocation");
  inEmail = document.getElementById("inEmail");
  inPhone = document.getElementById("inPhone");
  inWeb = document.getElementById("inWeb");
  radioAlert = radioContent.querySelector(".alert span");
  inDesc = document.getElementById("inDesc");
  elAudio = radioContent.querySelector("audio");
  pAudioAlert = document.getElementById("pAudioAlert").querySelector("span");
  btnRequestInfo = document.getElementById("btnRequestInfo");
  btnReject = document.getElementById("btnReject");
  btnApprove = document.getElementById("btnApprove");
  btnUpdate = document.getElementById("btnUpdate");
  btnGoStream = document.getElementById("btnGoStream");
  inAdminName = document.getElementById("inAdminName");
  pAdminId = document.getElementById("pAdminId").querySelector("span");
  iAdminId = document.getElementById("pAdminId").querySelector("i");
  pRequestDate = document.getElementById("pRequestDate").querySelector("span");
  iRequestDate = document.getElementById("pRequestDate").querySelector("i");
  pRadioId = document.getElementById("pRadioId").querySelector("span");
  iRadioId = document.getElementById("pRadioId").querySelector("i");
  btnBack = document.getElementById("btnBack");
  inWebStream = document.getElementById("inWebStream");
  dWelcome = document.getElementById("dWelcome");
  inWelcome = document.getElementById("inWelcome");
  dTestStream = document.getElementById("dTestStream");
  inTestUrl = document.getElementById("inTestUrl");
  lblTestUrl = document.getElementById("lblTestUrl");
  btnTestUrl = document.getElementById("btnTestUrl");
  btnAddCoinPack = document.getElementById("btnAddCoinPack");
  btnAddProduct = document.getElementById("btnAddProduct");
  btnClearSearch = document.getElementById("btnClearSearch");
  btnSearch = document.getElementById("btnSearch");
  divResults = document.getElementById("divResults");
  pResultLoader = document.getElementById("pResultLoader");
  pEmpty = divResults.querySelector(".empty");
  spName = document.getElementById("spName");
  spNotFound = document.getElementById("spNotFound");
  divSearchList = document.getElementById("divSearchList");
  inSearch = document.getElementById("inSearch");
  updatingModal = document.getElementById("updatingModal");
  btnGoWeb = document.getElementById("btnGoWeb");
  btnRadioRevision = document.getElementById("btnRadioRevision");
  progressModal = document.getElementById("progressModal");
  reviseRadios = document.getElementById("reviseRadios");
}

function checkWindowWidth() {
  var navDisplay = nav.style.display;
  if (window.innerWidth <= 840) {
    if (navDisplay == "" || navDisplay == "none") {
      btnToggleNav.title = trans.showNavMenu;
    } else {
      btnToggleNav.title = trans.hideNavMenu;
    }
  }
}

function checkUser() {
  const msg = progress.querySelector(".message");
  msg.textContent = trans.requestingInfo;
  setDisplay(progress, "flex");
  firebase.auth().onAuthStateChanged(function (user) {
    const btnLogin = login.querySelector("button");
    disableButton(btnLogin, false);
    if (user) {
      msg.textContent = trans.verifyingInfo;
      uid = user.uid;
      checkPermission(uid);
    } else {
      //Request login
      requestLogin();
    }
  });
}
function requestLogin() {
  setDisplay(progress, "none");
  setDisplay(login, "flex");
  const inputs = login.querySelectorAll("input");
  const elEmail = inputs[0];
  const elPass = inputs[1];
  const elMsg = login.querySelector(".message span");
  const btnLogin = login.querySelector("button");

  btnLogin.addEventListener("click", function () {
    var email = elEmail.value.trim();
    var pass = elPass.value.trim();
    if (email == "") {
      elMsg.textContent = trans.invalidEmail;
      setDisplay(login.querySelector(".message"), "flex");
      $(elEmail).shake();
    } else if (pass == "") {
      elMsg.textContent = trans.invalidPassword;
      setDisplay(login.querySelector(".message"), "flex");
      $(elPass).shake();
    } else {
      disableButton(btnLogin, true);
      loginUser(email, pass);
    }
  });
}

function loginUser(email, pass) {
  progress.querySelector(".message").textContent = trans.signingIn;
  setDisplay(progress, "flex");
  const inputs = login.querySelectorAll("input");
  const elEmail = inputs[0];
  const elPass = inputs[1];
  const elMsg = login.querySelector(".message span");
  const btnLogin = login.querySelector("button");

  firebase
    .auth()
    .signInWithEmailAndPassword(email, pass)
    .catch(function (error) {
      var errorCode = error.code;
      disableButton(btnLogin, false);
      setDisplay(login.querySelector(".message"), "block");
      setDisplay(progress, "none");
      switch (errorCode) {
        case "auth/invalid-email":
          elMsg.textContent = trans.invalidEmail;
          $(elEmail).shake();
          break;
        case "auth/user-disabled":
          elMsg.textContent = trans.userDisabled;
          break;
        case "auth/user-not-found":
          elMsg.textContent = trans.userNotFound;
          break;
        case "auth/wrong-password":
          elMsg.textContent = trans.invalidPassword;
          elPass.value = "";
          $(elPass).shake();
          break;
        default:
          elMsg.textContent = trans.unknownError;
          break;
      }
    });
}

function checkPermission(userId) {
  var adminRef = firebase.database().ref("App/cm-admin/" + userId);
  adminRef.on("value", function (data) {
    setDisplay(progress, "none");
    if (data.exists()) {
      //Authorized user
      setDisplay(login, "none");
      showToast(trans.loadingData, "toast");
      if (firstInit) {
        initClasses();
        initMainListeners();
        firstInit = false;
      }

      initData();
    } else {
      //Unauthorized user
      denyPermission();
    }
  });
}

function denyPermission() {
  var msg = login.querySelector(".message");
  msg.querySelector("span").textContent = trans.permissionDenied;
  setDisplay(msg, "flex");
  requestLogin();
}

function initMainListeners() {
  btnToggleNav.addEventListener("click", function () {
    toggleNav();
  });

  var copyButtons = links.querySelectorAll("button");
  var aLinks = links.querySelectorAll("a span");

  for (let index = 0; index < copyButtons.length; index++) {
    const element = copyButtons[index];
    element.addEventListener("click", function () {
      copyText(aLinks[index]);
      showToast("Text copied", "toast");
    });
  }

  var aTranslate = document.getElementById("aTranslate");
  aTranslate.addEventListener("click", function () {
    setDisplay("langDropdown", "flex");
  });

  window.onclick = function (event) {
    if (!event.target.matches(".dropbtn")) {
      setDisplay("langDropdown", "none");
    }
    if (!event.target.matches("#imgProfile")) {
      setDisplay(uOptions, "none");
    }
  };

  aEn.addEventListener("click", function () {
    translatePage("en");
  });

  aEs.addEventListener("click", function () {
    translatePage("es");
  });

  for (let index = 0; index < navs.length; index++) {
    const nav = navs[index];
    nav.addEventListener("click", function () {
      if (uid) {
        checkPhoneNav();
        displayContent(index);
      } else {
        showToast(trans.permissionDenied, "toast");
      }
    });
  }

  inScroll.querySelector(".uv").addEventListener("click", function () {
    verify.scrollIntoView();
  });

  inScroll.querySelector(".ve").addEventListener("click", function () {
    verified.scrollIntoView();
  });

  $(mainContent).scroll(function () {
    if (isMainContent && mainNav > 0) {
      scrollFunction(mainContent, inScroll, 50);
    }
  });

  imgProfile.addEventListener("click", function () {
    showUserOptions();
  });

  btnLogout.addEventListener("click", function () {
    confirmLogout();
  });

  signout.querySelector(".btn-close").addEventListener("click", function () {
    setDisplay(signout, "none");
  });

  signout.querySelector(".btn-blue").addEventListener("click", function () {
    logout();
  });
  confirmDialog
    .querySelector(".btn-close")
    .addEventListener("click", function () {
      setDisplay(confirmDialog, "none");
    });
  reasonDialog
    .querySelector(".btn-close")
    .addEventListener("click", function () {
      setDisplay(reasonDialog, "none");
    });
  podReasonDialog
    .querySelector(".btn-close")
    .addEventListener("click", function () {
      setDisplay(podReasonDialog, "none");
    });
  wdDeclineDialog
    .querySelector(".btn-close")
    .addEventListener("click", function () {
      setDisplay(wdDeclineDialog, "none");
    });
  btnBack.addEventListener("click", function () {
    showMainContent();
  });

  elAudio.addEventListener(
    "error",
    function (e) {
      var noSourcesLoaded =
        this.networkState === HTMLMediaElement.NETWORK_NO_SOURCE;
      initAudioAlert(noSourcesLoaded);
      // if (noSourcesLoaded) {
      //   initAudioAlert(true);
      // }
    },
    true,
  );

  btnTestUrl.addEventListener("click", function () {
    var url = inTestUrl.value.trim();
    if (url != "") {
      initAudio(url);
    } else {
      $(inTestUrl).shake();
    }
  });

  btnRequestInfo.addEventListener("click", function () {
    if (iRadioInfo != null && xRadioId != null) {
      showReasonDialog(false);
    }
  });

  btnReject.addEventListener("click", function () {
    if (iRadioInfo != null && xRadioId != null) {
      ConfirmDeleteRadio();
    }
  });

  btnApprove.addEventListener("click", function () {
    if (iRadioInfo != null && xRadioId != null) {
      confirmApproval();
    }
  });

  btnUpdate.addEventListener("click", function () {
    if (iRadioInfo != null && xRadioId != null) {
      updateRadio();
    }
  });
  var undoBtns = radioContent.querySelectorAll(".undo");
  for (let index = 0; index < undoBtns.length; index++) {
    const btnUndo = undoBtns[index];
    btnUndo.addEventListener("click", function () {
      if (iRadioInfo != null) {
        resetInput(index);
      }
    });
  }

  var lReasons = reasonDialog.querySelectorAll("input");
  lReasons.forEach((element) => {
    element.addEventListener("click", function () {
      setDisplay(taOther, rad4.checked ? "block" : "none");
    });
  });
  var wdReasons = wdDeclineDialog.querySelectorAll("input");
  wdReasons.forEach((element) => {
    element.addEventListener("click", function () {
      setDisplay(wdTaOther, wdRad3.checked ? "block" : "none");
    });
  });
  var lPodReasons = podReasonDialog.querySelectorAll("input");
  lPodReasons.forEach((element) => {
    element.addEventListener("click", function () {
      setDisplay(taPodOther, podRad4.checked ? "block" : "none");
    });
  });

  unverifiedTotal.addEventListener("click", function () {
    displayContent(1);
    verify.scrollIntoView();
  });

  radioTotal.addEventListener("click", function () {
    displayContent(1);
    verified.scrollIntoView();
  });

  userTotal.addEventListener("click", function () {
    displayContent(2);
  });

  unverifiedPodTotal.addEventListener("click", function () {
    displayContent(3);
    podVerify.scrollIntoView();
  });

  podTotal.addEventListener("click", function () {
    displayContent(3);
    podVerified.scrollIntoView();
  });

  var podUndoBtns = podContent.querySelectorAll(".undo");
  for (let index = 0; index < podUndoBtns.length; index++) {
    const btnUndo = podUndoBtns[index];
    btnUndo.addEventListener("click", function () {
      if (iPodContent != null) {
        resetPodInput(index);
      }
    });
  }

  //for podcasts
  btnRequestPodInfo.addEventListener("click", function () {
    if (iPodContent != null && xPodId != null) {
      showPodReasonDialog(false);
    }
  });

  btnRejectPod.addEventListener("click", function () {
    if (iPodContent != null && xPodId != null) {
      ConfirmDeletePod();
    }
  });

  btnApprovePod.addEventListener("click", function () {
    if (iPodContent != null && xPodId != null) {
      //todo: test approval, test send message, test reject
      //todo: feed and title unique in android (add url in podcast class if title taken
      //todo: ex: Talk Show > url = talk-show1) allow users to edit their url (check if unique)
      confirmPodApproval();
    }
  });

  btnUpdatePod.addEventListener("click", function () {});

  btnSearch.addEventListener("click", function () {
    var search = inSearch.value.trim();
    if (search) {
      searchGroup(search);
    }
  });
  btnClearSearch.addEventListener("click", function () {
    clearSearch();
  });
  inSearch.addEventListener("keyup", function (event) {
    if ("Enter" === event.key) {
      event.preventDefault();
      btnSearch.click();
    }
  });

  $(btnRadioRevision).click(function (e) {
    e.stopPropagation();
    addRadioRevision();
  });
}
function addRadioRevision() {
  if (iRadioInfo != null && xRadioId != null) {
    progressModal.querySelector("span").textContent = trans.addingRevision;
    setDisplay(progressModal, "flex");
    var reviseRef = firebase.database().ref(`checkRadio/${xRadioId}`);
    var date = new Date().getTime();
    reviseRef.set(date, function (error) {
      if (error) {
        showToast(trans.unknownError, "toast");
      } else {
        showToast(trans.successRevision, "toast");
      }
      setDisplay(progressModal, "none");
    });
  }
}
function updateRadio() {
  setDisplay(updatingModal, "flex");
  var nRadioClass = radioClass;
  nRadioClass.admin_ID = iRadioInfo.admin_ID;
  nRadioClass.admin_Name = iRadioInfo.admin_Name;
  nRadioClass.admin_Pass = iRadioInfo.admin_Pass
    ? iRadioInfo.admin_Pass
    : iRadioInfo.admin_pass
      ? iRadioInfo.admin_pass
      : "0";
  nRadioClass.radio_ID = xRadioId;
  nRadioClass.radio_image = iRadioInfo.radio_image
    ? iRadioInfo.radio_image
    : null;
  nRadioClass.banner = iRadioInfo.banner ? iRadioInfo.banner : null;

  var radioName = inRadioName.value.trim().replace(/--/g, "-");
  var slogan = inSlogan.value.trim();
  var stream = inStream.value.trim();
  var desc = inDesc.value.trim();
  var phone = inPhone.value.trim();
  var location = inLocation.value.trim();
  var email = inEmail.value.trim();
  var web = inWeb.value.trim();
  var webStream = inWebStream.value.trim();

  nRadioClass.radio_Name =
    radioName != "" ? radioName : iRadioInfo.radio_Name.replace(/--/g, "-");
  nRadioClass.radio_Slogan =
    slogan != ""
      ? slogan
      : iRadioInfo.radio_Slogan
        ? iRadioInfo.radio_Slogan
        : null;
  nRadioClass.phone_no =
    phone != "" ? phone : iRadioInfo.phone_no ? iRadioInfo.phone_no : null;
  nRadioClass.radio_location =
    location != "" ? location : iRadioInfo.radio_location;
  nRadioClass.radio_Stream = stream != "" ? stream : iRadioInfo.radio_Stream;
  nRadioClass.radio_Description =
    desc != "" ? desc : iRadioInfo.radio_Description;
  nRadioClass.radio_email =
    email != ""
      ? email
      : iRadioInfo.radio_email
        ? iRadioInfo.radio_email
        : null;
  nRadioClass.website =
    web != "" ? web : iRadioInfo.website ? iRadioInfo.website : null;
  nRadioClass.webStream =
    webStream != ""
      ? webStream
      : iRadioInfo.webStream
        ? iRadioInfo.webStream
        : null;

  if (
    nRadioClass.radio_email != null &&
    !nRadioClass.radio_email.includes("@")
  ) {
    nRadioClass.radio_email = null;
  }
  nRadioClass.lowCaseName = nRadioClass.radio_Name.toLowerCase();
  nRadioClass.date_created = iRadioInfo.date_created;
  // Check if name changed
  if (nRadioClass.radio_Name != iRadioInfo.radio_Name) {
    //check if radio name already exists
    checkRadioName(nRadioClass);
  } else if (nRadioClass.radio_Stream != iRadioInfo.radio_Stream) {
    //check if radio stream already exists
    checkRadioStream(nRadioClass);
  } else {
    //Nothing changed, upload info
    uploadRadioChanges(nRadioClass);
  }
}
function checkRadioName(nRadioClass) {
  var radiosRef = firebase.database().ref("Radio Stations");
  radiosRef
    .orderByChild("info/radio_Name")
    .equalTo(nRadioClass.radio_Name)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        //Radio name taken
        showToast(trans.errorRadioNameTaken, "toast");
        setDisplay(updatingModal, "none");
      } else if (nRadioClass.radio_Stream != iRadioInfo.radio_Stream) {
        //check if radio stream already exists
        checkRadioStream(nRadioClass);
      } else {
        //Nothing changed, upload info
        uploadRadioChanges(nRadioClass);
      }
    });
}

function checkRadioStream(nRadioClass) {
  var radiosRef = firebase.database().ref("Radio Stations");
  radiosRef
    .orderByChild("info/radio_Stream")
    .equalTo(nRadioClass.radio_Name)
    .once("value", function (snapshot) {
      if (snapshot.exists()) {
        //Radio name taken
        showToast(trans.errorRadioStreamTaken, "toast");
        setDisplay(updatingModal, "none");
      } else {
        //check if radio stream already exists
        uploadRadioChanges(nRadioClass);
      }
    });
}

function uploadRadioChanges(nRadioClass) {
  var radioRef = firebase
    .database()
    .ref("Radio Stations/" + xRadioId + "/info");
  radioRef.set(nRadioClass, function (error) {
    if (error) {
      showToast(trans.unknownError, "toast");
    } else {
      showToast(trans.successUpdate, "toast");
    }
    setDisplay(updatingModal, "none");
  });
}

function searchGroup(search) {
  if (searchType == null) {
    return;
  }
  setDisplay(btnClearSearch, "block");
  setDisplay(divResults, "block");
  setDisplay(pResultLoader, "block");
  setDisplay(pEmpty, "none");
  switch (searchType) {
    case SearchType.radio:
      searchRadios(search);
      break;
    case SearchType.pod:
      break;
    case SearchType.users:
      searchUsers(search);
      break;
    default:
      break;
  }
}
function searchUsers(search) {
  let lSearch = search.toLowerCase();

  var searchQuery = firebase
    .database()
    .ref("userSearch")
    .startAt(lSearch)
    .endAt(lSearch + "\uf8ff");
  searchQuery.once("value", function (data) {
    if (data.exists()) {
      setDisplay(pEmpty, "none");
      data.forEach(function (user) {
        let id = user.key;
        if (id != null) {
          if (document.getElementById(user.key + "search")) {
            divSearchList.textContent = "";
          }
          //get user info
          let dbUser = firebase.database().ref(`Users/${id}/info`);
          dbUser.once("value", function (info) {
            if (info.exists()) {
              addUser(
                user.key,
                "search",
                user.val().info,
                divSearchList,
                true,
                null,
              );
            }
          });
        }
      });
    } else {
      spName.textContent = search;
      setDisplay(pEmpty, "block");
      divSearchList.textContent = "";
    }
    setDisplay(pResultLoader, "none");
  });
}

function addUser(key, ext, user, parent, verified, radioAdmins) {
  if (key == null || user == null) {
    return;
  }

  var oldDiv = document.getElementById(key + ext);
  const container = document.createElement("div");
  container.innerHTML = RADIO_TEMPLATE;
  const divUser = container.firstChild;

  divUser.setAttribute("id", key + ext);

  const elName = divUser.querySelector(".name");
  const elTime = divUser.querySelector(".time");
  const elLogo = divUser.querySelector(".roundImg");
  const btnRemove = divUser.querySelector(".btnRemove");
  const btnEdit = divUser.querySelector(".btnEdit");

  var radioName = user.name;
  var radioLogo = user.profile_Image;
  var time = user.date_created;

  elName.textContent = radioName ? radioName : trans.noName;
  var creationTime = time
    ? formatMessageDate(new Date(time), trans.language)
    : formatMessageDate(new Date(), trans.language);

  elTime.textContent =
    creationTime == "Today"
      ? trans.today
      : creationTime == "Yesterday"
        ? trans.yesterday
        : creationTime;
  elLogo.src = radioLogo ? radioLogo : phRadioImg;

  divUser.addEventListener("click", function () {
    fromSearch = ext == "search" || btnClearSearch.style.display == "block";
    initUserContent(key, user);
  });

  if (ext == "check") {
    $(btnRemove).click(function (e) {
      e.stopPropagation();
      removeRevise(key);
    });
  } else {
    setDisplay(btnRemove, "none");
  }
  $(btnEdit).find("span").text(trans.edit);
  $(btnRemove).find("span").text(trans.remove);
  $(btnEdit).attr("title", trans.edit);
  $(btnRemove).attr("title", trans.remove);
  if (oldDiv) {
    parent.replaceChild(divUser, oldDiv);
  } else {
    const existingRadio = parent.children;
    if (existingRadio.length === 0) {
      parent.appendChild(divUser);
    } else {
      parent.insertBefore(divUser, parent.children[0]);
    }
  }
}

function initUserContent(key, user) {
  isMainContent = false;
  iUser = user;
  xUid = key;

  //   setDisplay(dTestStream, "none");
  //   setDisplay(mainContent, "none");
  //   setDisplay(editContent, "flex");
  //   setDisplay(podContent, "none");
  //   setDisplay(radioContent, "flex");
  //   setDisplay(search, "none");
  //   setDisplay(divResults, "none");
  //   //setDisplay(btnClearSearch, "none");
  //  setDisplay(btnReject, "block");
  //     setDisplay(btnApprove, "block");
  //     setDisplay(btnUpdate, "none");
  //     setDisplay(dWelcome, "none");

  //   var nAdminId = user.admin_ID;
  //   var nAdminName = user.admin_Name;
  //   var nRadioName = user.radio_Name;
  //   var nSlogan = user.radio_Slogan;
  //   var nStream = user.radio_Stream;
  //   var nDesc = user.radio_Description;
  //   var nRadioId = user.radio_ID;
  //   var nLogo = user.radio_image;
  //   var nTime = user.date_created;
  //   var nBanner = user.banner;
  //   var nPhone = user.phone_no;
  //   var nLocation = user.radio_location;
  //   var nEmail = user.radio_email;
  //   var nWeb = user.website;
  //   var nWelcome = user.welcome;
  //   var nWebStream = user.webStream;

  //   pAdminId.textContent = nAdminId ? nAdminId : "";
  //   inAdminName.value = nAdminName ? nAdminName : "";
  //   inRadioName.value = nRadioName;
  //   inSlogan.value = nSlogan ? nSlogan : "";
  //   inStream.value = nStream ? nStream : "";
  //   inDesc.value = nDesc ? nDesc : "";
  //   pRadioId.textContent = nRadioId ? nRadioId : key ? key : "";
  //   imgLogo.src = nLogo ? nLogo : phRadioImg;
  //   pRequestDate.textContent = nTime ? formatDate(new Date(nTime)) : "";
  //   imgBanner.src = nBanner ? nBanner : phBanner;
  //   inPhone.value = nPhone ? nPhone : "";
  //   inLocation.value = nLocation ? nLocation : "";
  //   inEmail.value = nEmail ? nEmail : "";
  //   inWeb.value = nWeb ? nWeb : "";
  //   inWelcome.value = nWelcome ? nWelcome : "";
  //   //btnGoStream.href = nStream ? nStream : "javascript:void(0);";
  //   var fullWeb = nWeb ? "$start" + nWeb : "javascript:void(0);";
  //   if (!fullWeb.includes("//")) {
  //     fullWeb = fullWeb.replace("$start", "//");
  //   } else {
  //     fullWeb = fullWeb.replace("$start", "");
  //   }
  //   $(btnGoWeb).off("click");
  //   if (nWeb) {
  //     $(btnGoWeb).click(function () {
  //       window.open(fullWeb, "_blank");
  //     });
  //   }
}

function searchRadios(search) {
  let lSearch = search.toLowerCase();

  var searchQuery = firebase
    .database()
    .ref("Radio Stations")
    .orderByChild("info/lowCaseName")
    .startAt(lSearch)
    .endAt(lSearch + "\uf8ff");
  searchQuery.once("value", function (data) {
    if (data.exists()) {
      setDisplay(pEmpty, "none");
      data.forEach(function (radio) {
        if (document.getElementById(radio.key + "search")) {
          divSearchList.textContent = "";
        }
        addRadio(
          radio.key,
          "search",
          radio.val().info,
          divSearchList,
          true,
          null,
        );
      });
    } else {
      spName.textContent = search;
      setDisplay(pEmpty, "block");
      divSearchList.textContent = "";
    }
    setDisplay(pResultLoader, "none");
  });
}
function checkPodName(nPod) {
  var podRef = firebase.database().ref("podcast");
  podRef
    .orderByChild("feed")
    .equalTo(nPod.feed)
    .once("value", function (data) {
      if (data.exists()) {
        setDisplay(progress, "none");
        showToast(trans.errorFeedExists, "toast");
        $(inFeed).shake();
      } else {
        var podRef = firebase.database().ref("podcast");
        podRef
          .orderByChild("title")
          .equalTo(nPod.title)
          .once("value", function (data) {
            if (data.exists()) {
              var lnk = nPod.title.replace(/--/g, "_");
              lnk = lnk.replace(/\s+/g, "-");
              lnk = lnk.replace(/_/g, "--");
              nPod.url = "p=" + lnk + "id=" + getRandomNum();
              // setDisplay(progress, "none");
              // showToast(trans.errorPodNameExists, "toast");
              // $(inPodTitle).shake();
              verifyPod(nPod);
            } else {
              verifyPod(nPod);
            }
          });
      }
    });
}

function confirmPodApproval() {
  const dialog = document.getElementById("confirmDialog");
  const btnRed = dialog.querySelector(".redBtn");
  const btnBlue = dialog.querySelector(".blueBtn");
  $(btnBlue).unbind();
  $(btnRed).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
    //check radio information for completion
    checkPodInfo();
  });

  $(btnRed).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
  });

  dialog.querySelector("h3 span").textContent = trans.confirmApprove;
  dialog.querySelector(".msg").innerHTML = trans.podApprovalMsg;
  setDisplay(dialog, "flex");
}

function checkPodInfo() {
  //inAdminName.value.trim(),inRadioName.value.trim(),
  //inDescription.value.trim(),inRadioStream.value.trim(),
  //inPassword.value.trim(),countries.value, inRadioEmail.value.trim())
  progress.querySelector(".message").innerHTML = trans.verifyingPodInfo;
  setDisplay(progress, "flex");
  var nPodClass = podClass;
  nPodClass.uid = iPodContent.uid;
  nPodClass.icon = iPodContent.icon ? iPodContent.icon : null;
  nPodClass.host = iPodContent.host ? iPodContent.host : null;
  nPodClass.lang = selPodLang.selectedIndex;
  nPodClass.genre = selGenres.selectedIndex;

  var email = inHostEmail.value.trim();
  var podEmail = inPodEmail.value.trim();
  var podName = inPodTitle.value.trim().replace(/--/g, "-");
  var feed = inFeed.value.trim();
  var desc = inPodDesc.value.trim();
  var country = getCountryCode(selPodCountry.selectedIndex).toLowerCase();

  var web = inPodWeb.value.trim().replace("n/a", "");
  var phone = inPodPhone.value.trim().replace("n/a", "");
  var fb = inFb.value.trim();
  var tw = inTw.value.trim();
  var ins = inIn.value.trim();
  var yt = inYt.value.trim();
  var tk = inTk.value.trim();
  var msgWelcome = inPodWelcome.value.trim().replace("n/a", "");
  nPodClass.fb = fb ? fb : iPodContent.fb ? iPodContent.fb : null;
  nPodClass.tw = tw ? tw : iPodContent.tw ? iPodContent.tw : null;
  nPodClass.ig = ins ? ins : iPodContent.ig ? iPodContent.ig : null;
  nPodClass.yt = yt ? yt : iPodContent.yt ? iPodContent.yt : null;
  nPodClass.tk = tk ? tk : iPodContent.tk ? iPodContent.tk : null;
  nPodClass.msgWelcome = msgWelcome
    ? msgWelcome
    : iPodContent.msgWelcome
      ? iPodContent.msgWelcome
      : null;
  nPodClass.title =
    podName != "" ? podName : iPodContent.title.replace(/--/g, "-");
  nPodClass.phone =
    phone != "" ? phone : iPodContent.phone ? iPodContent.phone : null;
  nPodClass.country = country != "" ? country : iPodContent.country;
  nPodClass.feed = feed != "" ? feed : iPodContent.feed;
  nPodClass.desc = desc != "" ? desc : iPodContent.desc;
  nPodClass.email =
    email != "" ? email : iPodContent.email ? iPodContent.email : null;
  nPodClass.pod_email =
    podEmail != ""
      ? podEmail
      : iPodContent.pod_email
        ? iPodContent.pod_email
        : null;
  nPodClass.web = web != "" ? web : iPodContent.web ? iPodContent.web : null;

  if (!nPodClass.pod_email.includes("@")) {
    nPodClass.pod_email = null;
  }
  nPodClass.lcTitle = nPodClass.title.toLowerCase();
  nPodClass.date = new Date().getTime();
  nPodClass.verified = true;
  checkPodName(nPodClass);
}

function verifyPod(nPod) {
  progress.querySelector(".message").innerHTML = trans.uploadingInfo;

  //Upload to Radio Stations
  var podRef = firebase.database().ref("podcast/" + xPodId);
  podRef.set(nPod, function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      var userPodRef = firebase
        .database()
        .ref("Users/" + nPod.uid + "/podcast/" + xPodId);
      userPodRef.set(true, function (error) {
        if (error) {
          podRef.remove();
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          var genreRef = firebase
            .database()
            .ref(`tag/genre/podcast/${nPod.genre}/${xPodId}`);
          genreRef.set(nPod.date, function (error) {
            if (error) {
              podRef.remove();
              setDisplay(progress, "none");
              showToast(trans.unknownError, "toast");
            } else {
              var countryRef = firebase
                .database()
                .ref(`tag/country/podcast/${nPod.country}/${xPodId}`);
              countryRef.set(nPod.date, function (error) {
                if (error) {
                  genreRef.remove();
                  podRef.remove();
                  setDisplay(progress, "none");
                  showToast(trans.unknownError, "toast");
                } else {
                  var langRef = firebase
                    .database()
                    .ref(`tag/lang/podcast/${nPod.lang}/${xPodId}`);
                  langRef.set(nPod.date, function (error) {
                    if (error) {
                      countryRef.remove();
                      genreRef.remove();
                      podRef.remove();
                      setDisplay(progress, "none");
                      showToast(trans.unknownError, "toast");
                    } else {
                      removePodVerify(nPod);
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  });
}
function removePodVerify(nPod) {
  progress.querySelector(".message").innerHTML = trans.verifyingInfo;
  setDisplay(progress, "flex");

  var verifyRef = firebase.database().ref(`verify/podcast/${xPodId}`);
  verifyRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      showMainContent();
      //Send Alert
      sendVerifiedPodAlert(nPod);
    }
  });
}

function sendVerifiedPodAlert(nPod) {
  progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
  var alert = {
    date: new Date().getTime(),
    type: "podcast",
    reason: 4,
    email: nPod.email ? nPod.email : null,
    rName: nPod.title ? nPod.title : null,
    uName: inPodAdmin.value ? inPodAdmin.value : null,
    msg: null,
    sub: trans.sub1,
    from: uiName,
    fromId: uid ? uid : null,
  };
  alert.sub = alert.sub.replace("$name", alert.rName ? alert.rName : "");
  var message = trans.approvePodEmail.replace("$name", nPod.title);
  var lnk = nPod.title.replace(/--/g, "_");
  lnk = lnk.replace(/\s+/g, "-");
  lnk = lnk.replace(/_/g, "--");
  message = message.replace(/\$wName/g, lnk);
  message = message.replace("$urlSsl", "");
  message += "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase.database().ref(`alert/${nPod.uid}/${xPodId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast", 2500);
    } else {
      //request sent
      showToast(trans.podApproved, "toast", 2500);
    }
  });
}
function resetPodInput(index) {
  switch (index) {
    case 0:
      var hostEmail = iPodContent.email;
      inHostEmail.value = hostEmail ? hostEmail : "";
      break;
    case 1:
      var title = iPodContent.title;
      inPodTitle.value = title ? title : "";
      break;
    case 2:
      var oDesc = iPodContent.desc;
      inPodDesc.value = oDesc ? oDesc : "";
      break;
    case 3:
      var oStream = iPodContent.feed;
      inFeed.value = oStream ? oStream : "";
      break;
    case 4:
      var genre = iPodContent.genre;
      selGenres.selectedIndex = genre ? genre : "";
      break;
    case 5:
      var lang = iPodContent.lang;
      selPodLang.selectedIndex = lang ? lang : "";
      break;
    case 6:
      var country = iPodContent.country;
      selPodCountry.selectedIndex = country
        ? getCountryIndex(country.toUpperCase())
        : getCountryIndex("US");
      break;
    case 7:
      var wMsg = iPodContent.welcomeMsg;
      inPodWelcome.value = wMsg ? wMsg : "n/a";
      break;
    case 8:
      var oWeb = iPodContent.web;
      inPodWeb.value = oWeb ? oWeb : "n/a";
      break;
    case 9:
      var phone = iPodContent.phone;
      inPodPhone.value = phone ? phone : "n/a";
      break;
    case 10:
      var podEmail = iPodContent.pod_email;
      inPodEmail.value = podEmail ? podEmail : "n/a";
      break;
    case 11:
      var fb = iPodContent.fb;
      inFb.value = fb ? fb : "";
      break;
    case 12:
      var tw = iPodContent.tw;
      inTw.value = tw ? tw : "";
      break;
    case 13:
      var insta = iPodContent.ig;
      inIn.value = insta ? insta : "";
      break;
    case 14:
      var yt = iPodContent.yt;
      inYt.value = yt ? yt : "";
      break;
    case 15:
      var tk = iPodContent.tk;
      inTk.value = tk ? tk : "";
      break;
    default:
      break;
  }
}
function confirmApproval() {
  const dialog = document.getElementById("confirmDialog");
  const btnRed = dialog.querySelector(".redBtn");
  const btnBlue = dialog.querySelector(".blueBtn");
  $(btnBlue).unbind();
  $(btnRed).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
    //check radio information for completion
    checkRadioInfo();
  });

  $(btnRed).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
  });

  dialog.querySelector("h3 span").textContent = trans.confirmApprove;
  dialog.querySelector(".msg").innerHTML = trans.approvalMsg;
  setDisplay(dialog, "flex");
}

function checkRadioInfo() {
  //inAdminName.value.trim(),inRadioName.value.trim(),
  //inDescription.value.trim(),inRadioStream.value.trim(),
  //inPassword.value.trim(),countries.value, inRadioEmail.value.trim())
  progress.querySelector(".message").innerHTML = trans.verifyingRadioInfo;
  setDisplay(progress, "flex");
  var nRadioClass = radioClass;
  nRadioClass.admin_ID = iRadioInfo.admin_ID;
  nRadioClass.admin_Name = iRadioInfo.admin_Name;
  nRadioClass.admin_Pass = iRadioInfo.admin_Pass
    ? iRadioInfo.admin_Pass
    : iRadioInfo.admin_pass
      ? iRadioInfo.admin_pass
      : "0";
  nRadioClass.radio_ID = xRadioId;
  nRadioClass.radio_image = iRadioInfo.radio_image
    ? iRadioInfo.radio_image
    : null;
  nRadioClass.banner = iRadioInfo.banner ? iRadioInfo.banner : null;

  var radioName = inRadioName.value.trim().replace(/--/g, "-");
  var slogan = inSlogan.value.trim();
  var stream = inStream.value.trim();
  var desc = inDesc.value.trim();
  var phone = inPhone.value.trim();
  var location = inLocation.value.trim();
  var email = inEmail.value.trim();
  var web = inWeb.value.trim();
  var webStream = inWebStream.value.trim();

  nRadioClass.radio_Name =
    radioName != "" ? radioName : iRadioInfo.radio_Name.replace(/--/g, "-");
  nRadioClass.radio_Slogan =
    slogan != ""
      ? slogan
      : iRadioInfo.radio_Slogan
        ? iRadioInfo.radio_Slogan
        : null;
  nRadioClass.phone_no =
    phone != "" ? phone : iRadioInfo.phone_no ? iRadioInfo.phone_no : null;
  nRadioClass.radio_location =
    location != "" ? location : iRadioInfo.radio_location;
  nRadioClass.radio_Stream = stream != "" ? stream : iRadioInfo.radio_Stream;
  nRadioClass.radio_Description =
    desc != "" ? desc : iRadioInfo.radio_Description;
  nRadioClass.radio_email =
    email != ""
      ? email
      : iRadioInfo.radio_email
        ? iRadioInfo.radio_email
        : null;
  nRadioClass.website =
    web != "" ? web : iRadioInfo.website ? iRadioInfo.website : null;
  nRadioClass.webStream =
    webStream != ""
      ? webStream
      : iRadioInfo.webStream
        ? iRadioInfo.webStream
        : null;

  if (!nRadioClass.radio_email.includes("@")) {
    nRadioClass.radio_email = null;
  }
  nRadioClass.lowCaseName = nRadioClass.radio_Name.toLowerCase();
  nRadioClass.date_created = new Date().getTime();
  verifyRadio(nRadioClass);
}

function verifyRadio(nRadio) {
  progress.querySelector(".message").innerHTML = trans.uploadingInfo;

  //Upload to Radio Stations
  var radiosRef = firebase
    .database()
    .ref("Radio Stations/" + xRadioId + "/info");
  radiosRef.set(nRadio, function (error) {
    if (error) {
      //message failed
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      //Upload radioInfo

      var userRadiosRef = firebase
        .database()
        .ref(
          "Users/" + nRadio.admin_ID + "/My_Radios/" + xRadioId + "/verified",
        );
      userRadiosRef.set(true, function (error) {
        if (error) {
          //message failed
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          //Upload userProfile
          if (xRadioAdmin.date_created) {
            xRadioAdmin.date_created = nRadio.date_created;
          }
          var adminRadioRef = firebase
            .database()
            .ref(
              "Radio Stations/" +
                xRadioId +
                "/Administrators/" +
                nRadio.admin_ID,
            );
          adminRadioRef.set(xRadioAdmin, function (error) {
            if (error) {
              //message failed
              setDisplay(progress, "none");
              showToast(trans.unknownError, "toast");
            } else {
              //delete unverified reference
              var ownerRef = firebase
                .database()
                .ref("owner/" + xRadioId + "/" + nRadio.admin_ID);
              var role = {
                date: nRadio.date_created,
                img: xRadioAdmin.profile_Image
                  ? xRadioAdmin.profile_Image
                  : null,
                lcName: xRadioAdmin.name.toLowerCase(),
                name: xRadioAdmin.name,
                owner: true,
              };
              ownerRef.set(role, function (error) {
                if (error) {
                  setDisplay(progress, "none");
                  showToast(trans.unknownError, "toast");
                } else {
                  var roleRef = firebase
                    .database()
                    .ref(`role/${nRadio.admin_ID}/${xRadioId}/owner`);
                  roleRef.set(true, function (error) {
                    if (error) {
                      setDisplay(progress, "none");
                      showToast(trans.unknownError, "toast");
                    } else {
                      removeVerify(nRadio);
                    }
                  });
                }
              });
            }
          });
        }
      });
    }
  });
}

function removeVerify(nRadio) {
  progress.querySelector(".message").innerHTML = trans.verifyingInfo;
  setDisplay(progress, "flex");

  var verifyRef = firebase.database().ref(`verify/radio/${xRadioId}`);
  verifyRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      showMainContent();
      //Send Alert
      sendVerifiedAlert(nRadio);
    }
  });
}

function sendVerifiedAlert(nRadio) {
  progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
  var alert = {
    date: new Date().getTime(),
    type: "radio",
    reason: 4,
    email: nRadio.radio_email ? nRadio.radio_email : null,
    rName: nRadio.radio_Name ? nRadio.radio_Name : null,
    uName: nRadio.admin_Name ? nRadio.admin_Name : null,
    msg: null,
    sub: trans.sub1,
    from: uiName,
    fromId: uid ? uid : null,
  };
  alert.sub = alert.sub.replace("$name", alert.rName ? alert.rName : "");
  var message = trans.approveEmail.replace("$name", nRadio.radio_Name);
  var lnk = nRadio.radio_Name.replace(/--/g, "_");
  lnk = lnk.replace(/\s+/g, "-");
  lnk = lnk.replace(/_/g, "--");
  message = message.replace(/\$wName/g, lnk);
  if (!nRadio.radio_Stream.startsWith("https") && nRadio.webStream == null) {
    message = message.replace("$urlSsl", trans.urlUnsecureMsg);
  } else {
    message = message.replace("$urlSsl", "");
  }
  message += "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase
    .database()
    .ref(`alert/${nRadio.admin_ID}/${xRadioId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast", 2500);
    } else {
      //request sent
      showToast(trans.radioApproved, "toast", 2500);
    }
  });
}
function showMainContent() {
  isMainContent = true;
  setDisplay(editContent, "none");
  setDisplay(mainContent, "flex");
  setDisplay(search, mainNav > 0 ? "flex" : "none");
  setDisplay(divResults, fromSearch ? "block" : "none");
  inTestUrl.value = "";
}
function ConfirmDeleteRadio() {
  const dialog = document.getElementById("confirmDialog");
  const btnRed = dialog.querySelector(".redBtn");
  const btnBlue = dialog.querySelector(".blueBtn");
  $(btnBlue).unbind();
  $(btnRed).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
    showReasonDialog(true);
  });

  $(btnRed).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
  });

  dialog.querySelector("h3 span").textContent = trans.confirmRemoval;
  dialog.querySelector(".msg").innerHTML = trans.confirmRemovalMsg.replace(
    "$name",
    iRadioInfo.radio_Name,
  );
  setDisplay(dialog, "flex");
}

function ConfirmDeletePod() {
  const dialog = document.getElementById("confirmDialog");
  const btnRed = dialog.querySelector(".redBtn");
  const btnBlue = dialog.querySelector(".blueBtn");
  $(btnBlue).unbind();
  $(btnRed).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
    showPodReasonDialog(true);
  });

  $(btnRed).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
  });

  dialog.querySelector("h3 span").textContent = trans.confirmRemoval;
  dialog.querySelector(".msg").innerHTML = trans.confirmRemovalMsg.replace(
    "$name",
    iPodContent.title,
  );
  setDisplay(dialog, "flex");
}

function showReasonDialog(isRemoving) {
  const rDialog = document.getElementById("reasonDialog");
  const btnBlue = rDialog.querySelector(".blueBtn");

  $(btnBlue).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation;
    var numReason = rad1.checked ? 1 : rad2.checked ? 2 : rad4.checked ? 4 : 3;
    if (isRemoving) {
      if (iVerified) {
        purgeRadio(numReason);
      } else {
        deleteRadio(numReason);
      }
      setDisplay(rDialog, "none");
    } else {
      if (numReason != 4) {
        setDisplay(rDialog, "none");
        sendMessage(numReason);
      } else if (taOther.value.trim() != "") {
        setDisplay(rDialog, "none");
        sendMessage(numReason);
      } else {
        $(taOther).shake();
        showToast(trans.provideReason, "toast");
      }
    }
  });

  var name = iRadioInfo.admin_Name
    ? iRadioInfo.admin_Name
    : iRadioInfo.radio_Name
      ? iRadioInfo.radio_Name
      : "";
  rDialog.querySelector(".note").innerHTML = trans.removalNote.replace(
    "$name",
    name,
  );
  setDisplay(rDialog, "flex");
}

function showPodReasonDialog(isRemoving) {
  const rDialog = document.getElementById("podReasonDialog");
  const btnBlue = rDialog.querySelector(".blueBtn");

  $(btnBlue).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation;
    var numReason = podRad1.checked
      ? 1
      : podRad2.checked
        ? 2
        : podRad4.checked
          ? 4
          : 3;
    if (isRemoving) {
      if (iVerified) {
        purgePod(numReason);
      } else {
        deletePod(numReason);
      }
      setDisplay(rDialog, "none");
    } else {
      if (numReason != 4) {
        setDisplay(rDialog, "none");
        sendPodMessage(numReason);
      } else if (taPodOther.value.trim() != "") {
        setDisplay(rDialog, "none");
        sendPodMessage(numReason);
      } else {
        $(taPodOther).shake();
        showToast(trans.provideReason, "toast");
      }
    }
  });
  var host = inPodAdmin.value;
  var name = host ? host : iPodContent.title ? iPodContent.title : "";
  rDialog.querySelector(".note").innerHTML = trans.removalNote.replace(
    "$name",
    name,
  );
  setDisplay(rDialog, "flex");
}

function sendPodMessage(nReason) {
  progress.querySelector(".message").innerHTML = trans.sendingMessage;
  var alert = {
    date: new Date().getTime(),
    type: "radio",
    reason: nReason,
    email: iPodContent.email ? iPodContent.email : null,
    rName: iPodContent.title ? iPodContent.title : null,
    uName: inPodAdmin.value ? inPodAdmin.value : null,
    msg: null,
    sub: null,
    from: uiName,
    fromId: uid ? uid : null,
  };
  var message = trans.m4 + "<br><br>";
  switch (nReason) {
    case 1:
      alert.sub = trans.sub2;
      message += trans.r1 + "<br>" + trans.m1;
      break;
    case 2:
      alert.sub = trans.sub2;
      message += trans.r2 + "<br>" + trans.m2Pod;
      break;
    case 3:
      alert.sub = trans.sub3;
      message += trans.r3 + "<br>" + trans.m3Pod;
      break;
    case 4:
      alert.sub = trans.sub4.replace("$name", iPodContent.title);
      message += taPodOther.value.trim();
      break;
    default:
      alert.sub = "$name|ChatMurcianys";
      break;
  }

  alert.sub = alert.sub.replace("$name", iPodContent.title);
  var lnk;
  var msgPodInfo;
  if (iVerified) {
    lnk = iPodContent.title.replace(/--/g, "_");
    lnk = lnk.replace(/\s+/g, "-");
    lnk = lnk.replace(/_/g, "--");
  } else {
    lnk = xPodId;
  }

  var msgPodInfo = trans.updatePodInfo.replace(/\$id/g, lnk);
  msgPodInfo = msgPodInfo.replace(/\#/g, iVerified ? "" : "u");
  message += "<br><br>" + msgPodInfo + "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase.database().ref(`alert/${iPodContent.uid}/${xPodId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast");
    } else {
      //request sent
      taPodOther.value = "";
      podRad1.checked = true;
      showToast(trans.messageSent, "toast");
    }
  });
}
function deletePod(nReason) {
  progress.querySelector(".message").innerHTML = trans.removingPod;
  setDisplay(progress, "flex");

  var verifyRef = firebase.database().ref(`verify/podcast/${xPodId}`);
  verifyRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      var userPodRef = firebase
        .database()
        .ref(`Users/${iPodContent.uid}/podcast/${xPodId}`);
      userPodRef.remove(function (error) {
        showMainContent();
        if (error) {
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          //Check if radio has images
          if (iPodContent.icon) {
            purgePodImages(nReason);
          } else {
            sendPodRemovalReason(nReason);
          }
        }
      });
    }
  });
}
function sendMessage(nReason) {
  progress.querySelector(".message").innerHTML = trans.sendingMessage;
  var alert = {
    date: new Date().getTime(),
    type: "radio",
    reason: nReason,
    email: iRadioInfo.radio_email ? iRadioInfo.radio_email : null,
    rName: iRadioInfo.radio_Name ? iRadioInfo.radio_Name : null,
    uName: iRadioInfo.admin_Name ? iRadioInfo.admin_Name : null,
    msg: null,
    sub: null,
    from: uiName,
    fromId: uid ? uid : null,
  };
  var message = trans.m4 + "<br><br>";
  switch (nReason) {
    case 1:
      alert.sub = trans.sub2;
      message += trans.r1 + "<br>" + trans.m1;
      break;
    case 2:
      alert.sub = trans.sub2;
      message += trans.r2 + "<br>" + trans.m2;
      break;
    case 3:
      alert.sub = trans.sub3;
      message += trans.r3 + "<br>" + trans.m3;
      break;
    case 4:
      alert.sub = trans.sub4.replace("$name", iRadioInfo.radio_Name);
      message += taOther.value.trim();
      break;
    default:
      alert.sub = "$name|ChatMurcianys";
      break;
  }

  alert.sub = alert.sub.replace("$name", iRadioInfo.radio_Name);
  var lnk;
  if (iVerified) {
    lnk = iRadioInfo.radio_Name.replace(/--/g, "_");
    lnk = lnk.replace(/\s+/g, "-");
    lnk = lnk.replace(/_/g, "--");
  } else {
    lnk = xRadioId;
  }

  var msgRadioInfo = trans.updateRadioInfo.replace(/\$id/g, lnk);
  msgRadioInfo = msgRadioInfo.replace(/\#/g, iVerified ? "" : "u");
  message += "<br><br>" + msgRadioInfo + "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase
    .database()
    .ref(`alert/${iRadioInfo.admin_ID}/${xRadioId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast");
    } else {
      //request sent
      taOther.value = "";
      rad1.checked = true;
      showToast(trans.messageSent, "toast");
    }
  });
}

function deleteRadio(nReason) {
  progress.querySelector(".message").innerHTML = trans.removingRadio;
  setDisplay(progress, "flex");

  var verifyRef = firebase.database().ref(`verify/radio/${xRadioId}`);
  verifyRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      var userRadioRef = firebase
        .database()
        .ref(`Users/${iRadioInfo.admin_ID}/My_Radios/${xRadioId}`);
      userRadioRef.remove(function (error) {
        showMainContent();
        if (error) {
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          //Check if radio has images
          if (iRadioInfo.banner || iRadioInfo.radio_image) {
            purgeRadioImages(nReason);
          } else {
            sendRemovalReason(nReason);
          }
        }
      });
    }
  });
}

function purgeRadioImages(nReason) {
  const storageRef = firebase.storage().ref();
  if (iRadioInfo.banner) {
    //Radio has banner
    var bannerRef = storageRef.child(`Radio Stations/${xRadioId}/Banner`);
    bannerRef.delete().then(() => {
      if (iRadioInfo.radio_image) {
        var logoRef = storageRef.child(`Radio Stations/${xRadioId}/Logo`);
        logoRef
          .delete()
          .then(() => {
            sendRemovalReason(nReason);
          })
          .catch((error) => {
            console.log("error: " + error);
            sendRemovalReason(nReason);
          });
      } else {
        sendRemovalReason(nReason);
      }
    });
  } else if (iRadioInfo.radio_image) {
    //Radio has logo
    var logoRef = storageRef.child(`Radio Stations/${xRadioId}/Logo`);
    logoRef
      .delete()
      .then(() => {
        sendRemovalReason(nReason);
      })
      .catch((error) => {
        sendRemovalReason(nReason);
        console.log("error: " + error);
      });
  } else {
    sendRemovalReason(nReason);
  }
}

function sendRemovalReason(nReason) {
  progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
  var alert = {
    date: new Date().getTime(),
    type: "radio",
    reason: nReason,
    email: iRadioInfo.radio_email ? iRadioInfo.radio_email : null,
    rName: iRadioInfo.radio_Name ? iRadioInfo.radio_Name : null,
    uName: iRadioInfo.admin_Name ? iRadioInfo.admin_Name : null,
    msg: null,
    sub: null,
    from: uiName,
    fromId: uid ? uid : null,
  };
  var message = trans.rmnMessage.replace("$name", iRadioInfo.radio_Name);
  switch (nReason) {
    case 1:
      alert.sub = trans.sub2;
      message += trans.r1 + "<br>" + trans.m1;
      break;
    case 2:
      alert.sub = trans.sub2;
      message += trans.r2 + "<br>" + trans.m2;
      break;
    case 3:
      alert.sub = trans.sub3;
      message += trans.r3 + "<br>" + trans.m3;
      break;
    case 4:
      alert.sub = trans.sub4;
      message += taOther.value;
      break;
    default:
      alert.sub = "$name|ChatMurcianys";
      break;
  }

  alert.sub = alert.sub.replace("$name", iRadioInfo.name);
  message += "<br><br>" + trans.reSubmitRadio + "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase
    .database()
    .ref(`alert/${iRadioInfo.admin_ID}/${xRadioId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast", 2500);
    } else {
      //request sent
      showToast(trans.radioRemoved, "toast", 2500);
    }
  });
}

/**
 * remove radio from Radio Stations, My_Radios,
 * delete icons, and delete Chats/radioId
 */
function purgeRadio(nReason) {
  progress.querySelector(".message").innerHTML = trans.removingRadio;
  setDisplay(progress, "flex");

  var radioRef = firebase.database().ref(`Radio Stations/${xRadioId}`);
  radioRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      var userRadioRef = firebase
        .database()
        .ref(`Users/${iRadioInfo.admin_ID}/My_Radios/${xRadioId}`);
      userRadioRef.remove(function (error) {
        if (error) {
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          //delete chat room
          progress.querySelector(".message").innerHTML = trans.removingChat;
          var chatRef = firebase.database().ref(`Chats/${xRadioId}`);
          chatRef.remove(function (error) {
            if (error) {
              showToast(trans.errorChat, "toast");
            }
            //Check if radio has images
            if (iRadioInfo.banner || iRadioInfo.radio_image) {
              progress.querySelector(".message").innerHTML =
                trans.removingImages;
              purgeRadioImages(nReason);
            } else {
              sendRemovalReason(nReason);
            }
            showMainContent();
          });
        }
      });
    }
  });
}

/**
 * remove podcast from Podcasts, users podcast,
 * delete icons, pod like/podcast, tags, and delete Chats/podId
 */
function purgePod(nReason) {
  progress.querySelector(".message").innerHTML = trans.removingPod;
  setDisplay(progress, "flex");

  var podRef = firebase.database().ref(`podcast/${xPodId}`);
  podRef.remove(function (error) {
    if (error) {
      setDisplay(progress, "none");
      showToast(trans.unknownError, "toast");
    } else {
      var userPodRef = firebase
        .database()
        .ref(`Users/${iPodContent.uid}/podcast/${xPodId}`);
      userPodRef.remove(function (error) {
        if (error) {
          setDisplay(progress, "none");
          showToast(trans.unknownError, "toast");
        } else {
          //delete chat roomtrans.error
          progress.querySelector(".message").innerHTML = trans.removingChat;
          var chatRef = firebase.database().ref(`Chats/${xPodId}`);
          chatRef.remove(function (error) {
            if (error) {
              showToast(trans.errorChat, "toast");
            }
            var genreRef = firebase
              .database()
              .ref(`tag/genre/podcast/${iPodContent.genre}/${xPodId}`);
            genreRef.remove(function (error) {
              if (error) {
                showToast(trans.errorChat, "toast");
              }
              var countryRef = firebase
                .database()
                .ref(`tag/country/podcast/${iPodContent.country}/${xPodId}`);
              countryRef.remove(function (error) {
                if (error) {
                  showToast(trans.errorChat, "toast");
                }
                var langRef = firebase
                  .database()
                  .ref(`tag/lang/podcast/${iPodContent.lang}/${xPodId}`);
                langRef.remove(function (error) {
                  if (error) {
                    showToast(trans.errorChat, "toast");
                  }
                  //Check if podcast has images
                  if (iPodContent.icon) {
                    progress.querySelector(".message").innerHTML =
                      trans.removingImages;
                    purgePodImages(nReason);
                  } else {
                    sendPodRemovalReason(nReason);
                  }
                  showMainContent();
                });
              });
            });
          });
        }
      });
    }
  });
}

function purgePodImages(nReason) {
  const storageRef = firebase.storage().ref();
  if (iPodContent.icon) {
    //Radio has logo
    var logoRef = storageRef.child(`podcast/${xPodId}/logo`);
    logoRef
      .delete()
      .then(() => {
        sendPodRemovalReason(nReason);
      })
      .catch((error) => {
        sendPodRemovalReason(nReason);
      });
  } else {
    sendPodRemovalReason(nReason);
  }
}

function sendPodRemovalReason(nReason) {
  progress.querySelector(".message").innerHTML = trans.sendingConfirmation;
  var alert = {
    date: new Date().getTime(),
    type: "podcast",
    reason: nReason,
    email: iPodContent.email ? iPodContent.email : null,
    rName: iPodContent.title ? iPodContent.title : null,
    uName: inPodAdmin.value ? inPodAdmin.value : null,
    msg: null,
    sub: null,
    from: uiName,
    fromId: uid ? uid : null,
  };
  var message = trans.rmnMessage.replace("$name", iPodContent.title);
  switch (nReason) {
    case 1:
      alert.sub = trans.sub2;
      message += trans.r1 + "<br>" + trans.m1;
      break;
    case 2:
      alert.sub = trans.sub2;
      message += trans.r2 + "<br>" + trans.m2Pod;
      break;
    case 3:
      alert.sub = trans.sub3;
      message += trans.r3 + "<br>" + trans.m3Pod;
      break;
    case 4:
      alert.sub = trans.sub4;
      message += taPodOther.value;
      break;
    default:
      alert.sub = "$name|ChatMurcianys";
      break;
  }

  alert.sub = alert.sub.replace("$name", iPodContent.title);
  message += "<br><br>" + trans.reSubmitPod + "<br><br>" + trans.concludeMsg;
  alert.msg = message;
  var verifyRef = firebase.database().ref(`alert/${iPodContent.uid}/${xPodId}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      //request failed
      showToast(trans.unknownError, "toast", 2500);
    } else {
      //request sent
      showToast(trans.podRemoved, "toast", 2500);
    }
  });
}
function resetInput(index) {
  switch (index) {
    case 0:
      var oRadioName = iRadioInfo.radio_Name;
      inRadioName.value = oRadioName ? oRadioName : "";
      break;
    case 1:
      var oSlogan = iRadioInfo.radio_Slogan;
      inSlogan.value = oSlogan ? oSlogan : "";
      break;
    case 2:
      var oDesc = iRadioInfo.radio_Description;
      inDesc.value = oDesc ? oDesc : "";
      break;
    case 3:
      var oStream = iRadioInfo.radio_Stream;
      inStream.value = oStream ? oStream : "";
      break;
    case 4:
      var oWebStream = iRadioInfo.webStream;
      inWebStream.value = oWebStream ? oWebStream : "";
      break;
    case 5:
      var oLocation = iRadioInfo.radio_location;
      inLocation.value = oLocation ? oLocation : "";
      break;
    case 6:
      var oEmail = iRadioInfo.radio_email;
      inEmail.value = oEmail ? oEmail : "";
      break;
    case 7:
      var oPhone = iRadioInfo.phone_no;
      inPhone.value = oPhone ? oPhone : "";
      break;
    case 8:
      var oWeb = iRadioInfo.website;
      inWeb.value = oWeb ? oWeb : "";
      break;
    case 9:
      var oWelcome = iRadioInfo.welcome;
      inWelcome.value = oWelcome ? oWelcome : "";
      break;
    default:
      break;
  }
}
function initClasses() {
  radioClass = {
    admin_ID: null,
    admin_Name: null,
    admin_Pass: null,
    radio_Name: null,
    radio_Slogan: null,
    radio_Stream: null,
    radio_Description: null,
    radio_ID: null,
    radio_image: null,
    date_created: null,
    banner: null,
    phone_no: null,
    radio_location: null,
    radio_email: null,
    website: null,
    lowCaseName: null,
    welcome: null,
    webStream: null,
  };

  podClass = {
    email: null,
    pod_email: null,
    title: null,
    lcTitle: null,
    host: null,
    uid: null,
    pid: null,
    desc: null,
    feed: null,
    web: null,
    phone: null,
    lang: null,
    country: null,
    genre: null,
    fb: null,
    tw: null,
    ig: null,
    tk: null,
    yt: null,
    wa: null,
    msgWelcome: null,
    icon: null,
    likes: null,
    date: null,
    revenue: null,
    screenBlock: null,
    verified: null,
    donation: null,
    url: null,
  };
}

function initAudioAlert(fromError) {
  var msg = "";
  if (fromError) {
    msg += trans.errorAudio;
  }
  if (!elAudio.currentSrc.includes("https")) {
    if (msg == "") {
      msg = trans.unsecureUrl;
    } else {
      msg += "<br>" + trans.unsecureUrl;
    }
  }

  dTestStream.style.background = msg == "" ? "#e8f1ff" : "#ffcccc";

  pAudioAlert.innerHTML = msg;
  setDisplay(dTestStream, "flex");
}
function confirmLogout() {
  setDisplay(signout, "flex");
  const msg = progress.querySelector(".message");
  msg.textContent = trans.signingOut;
}

function logout() {
  setDisplay(signout, "none");
  if (uid) {
    setDisplay(progress, "flex");
    firebase
      .auth()
      .signOut()
      .then(function () {
        uid = null;
        setDisplay(progress, "none");
        setDisplay(login, "flex");
      });
  } else {
    showToast(trans.userNotFound, "toast");
  }
}

function showUserOptions() {
  var dis = uOptions.style.display;
  if (dis == "flex") {
    setDisplay(uOptions, "none");
  } else {
    setDisplay(uOptions, "flex");
  }
}

function scrollFunction(elParent, elScroll, px) {
  if (elParent.scrollTop > px) {
    setDisplay(elScroll, "flex");
  } else {
    setDisplay(elScroll, "none");
  }
}

function displayContent(index) {
  if (mainNav == index) {
    if (mainContent.style.display == "none") {
      setDisplay(editContent, "none");
      setDisplay(mainContent, "flex");
    }
    return;
  }
  isMainContent = true;
  setDisplay(editContent, "none");
  setDisplay(mainContent, "flex");
  setDisplay(dTestStream, "none");
  setDisplay(search, index > 0 ? "flex" : "none");
  //setDisplay(divResults, index > 0 ? "block" : "none");
  setDisplay(inScroll, "none");
  for (let meat = 0; meat < navMeat.length; meat++) {
    const navM = navMeat[meat];

    if (index == meat) {
      setDisplay(navM, "flex");
      navs[meat].className += "selected";
      initMeat(index);
    } else {
      setDisplay(navM, "none");
      navs[meat].className = navs[index].className.replace("selected", "");
    }
  }
  mainNav = index;
  navContent.querySelector("h2").textContent = navTitles[mainNav].textContent;
}

function toggleNav() {
  var navDisplay = nav.style.display;
  if (window.innerWidth <= 840) {
    if (navDisplay == "" || navDisplay == "none") {
      setDisplay(nav, "flex");
      btnToggleNav.title = trans.hideNavMenu;
    } else {
      setDisplay(nav, "none");
      btnToggleNav.title = trans.showNavMenu;
    }
  } else {
    if (navDisplay == "" || navDisplay == "flex") {
      setDisplay(nav, "none");
      btnToggleNav.title = trans.showNavMenu;
    } else {
      setDisplay(nav, "flex");
      btnToggleNav.title = trans.hideNavMenu;
    }
  }
}
function checkPhoneNav() {
  if (window.innerWidth <= 840) {
    var navDisplay = nav.style.display;
    if (navDisplay == "" || navDisplay == "none") {
      setDisplay(nav, "flex");
      btnToggleNav.title = trans.hideNavMenu;
    } else {
      setDisplay(nav, "none");
      btnToggleNav.title = trans.showNavMenu;
    }
  }
}
function initData() {
  if (userRef != null) {
    userRef.off();
  }

  userRef = firebase.database().ref("Users/" + uid + "/info");
  userRef.on("value", function (data) {
    if (data.exists()) {
      var user = data.val();
      updateUser(user);
    }
  });

  var vRadioCountRef = firebase.database().ref("radioCount/verified");
  vRadioCountRef.on("value", function (data) {
    var total = data.val();
    radioTotal.querySelector("span").textContent = total ? total : "0";
  });

  var uvRadioCountRef = firebase.database().ref("radioCount/unverified");
  uvRadioCountRef.on("value", function (data) {
    var total = data.val();
    unverifiedTotal.querySelector("span").textContent = total ? total : "0";
  });

  var userCountRef = firebase.database().ref("user/count");
  userCountRef.on("value", function (data) {
    var total = data.val();
    //console.log(numeral(total).format('0,0'));

    userTotal.querySelector("span").textContent = total
      ? numeral(total).format("0,0")
      : "0";
  });

  var versionRef = firebase.database().ref("App/version");
  versionRef.on("value", function (data) {
    var version = data.val();

    appInfo.querySelector("span").textContent = version ? version : "0";
  });

  var vPodCountRef = firebase.database().ref("podCount/verified");
  vPodCountRef.on("value", function (data) {
    var total = data.val();
    podTotal.querySelector("span").textContent = total ? total : "0";
  });

  var uvPodCountRef = firebase.database().ref("podCount/unverified");
  uvPodCountRef.on("value", function (data) {
    var total = data.val();
    unverifiedPodTotal.querySelector("span").textContent = total ? total : "0";
  });

  // var radiosRef = firebase.database().ref('Radio Stations');
  // radiosRef.once("value", function(snapshot) {
  //     if(snapshot.exists())
  //     {
  //         const total = snapshot.numChildren();
  //         console.log("total: " + total);
  //         // snapshot.forEach(function(childSnapshot) {
  //         //     var radioId = childSnapshot.key;
  //         //     var admin = childSnapshot.val().info.admin_ID;
  //         //     if (admin) {
  //         //         var radiosRef = firebase.database().ref(`Users/${admin}/My_Radios/${radioId}/`);

  //         //     }
  //         // });
  //      }
  // });

  // var ref = firebase.database().ref("Users");
  // ref.once('value').then(function(snapshot) {
  //     const total = snapshot.numChildren();
  //     var verifiedRef = firebase.database().ref('user/count');
  //     verifiedRef.set(snapshot.numChildren(),function(error){
  //         if(error)
  //         {
  //             //request failed
  //             showToast("Could not update users", "toast");
  //         }
  //         else{
  //             //request sent
  //             showToast("Users updated: " + total, "toast");
  //         }
  //     });
  // });
}

function updateUser(user) {
  if (user) {
    var name = user.name;
    var img = user.profile_Image;
    var email = user.email;
    uiName = name;
    var uOptions = document.getElementById("uOptions");
    var info = uOptions.querySelectorAll("div");
    info[0].textContent = name;
    info[1].textContent = email;
    imgProfile.src = img ? img : phPerson;
  }
}

function initMeat(index) {
  switch (index) {
    case 1:
      initRadios();
      break;
    case 2:
      initUsers();
      break;
    case 3:
      initPods();
      break;
    case 4:
      initInAppProducts();
      break;
    case 5:
      initWd();
      break;
  }
}
function initWd() {
  searchType = SearchType.wd;
  if (wdRef == null) {
    const divWds = document.getElementById("wds");
    const divWdInfo = document.getElementById("wdInfoFrag");
    const wdList = divWds.querySelector(".wdList");
    const uvEmpty = divWds.querySelector("p.empty");
    const btnGoWdRequests = document.getElementById("btnGoWdRequests");
    wdRef = purchaseApp.ref("wd");
    userWdRef = purchaseApp.ref("withdraw");
    balanceRef = purchaseApp.ref("balance");
    approvedWdRef = purchaseApp.ref("wdApproved");
    wdRef.on("child_added", function (data) {
      getWdInfo(
        data.key,
        data.val(),
        wdList,
        uvEmpty,
        divWds,
        divWdInfo,
        btnGoWdRequests,
      );
    });
    wdRef.on("child_removed", function (data) {
      deleteElement(data.key);
      if (wdList.children.length === 0) {
        setDisplay(uvEmpty, "block");
      }
    });

    btnGoWdRequests.addEventListener("click", function () {
      goToWdReq(divWds, divWdInfo, btnGoWdRequests);
    });
    //const
  }
}

function goToWdReq(divWds, divWdInfo, btnGoWdReq) {
  setDisplay(divWds, "flex");
  setDisplay(divWdInfo, "none");
  setDisplay(btnGoWdReq, "none");
}
function getWdInfo(
  key,
  uid,
  parent,
  uvEmpty,
  divWds,
  divWdInfo,
  btnGoWdRequests,
) {
  userWdRef.child(`${uid}/${key}`).once("value", function (data) {
    if (data.exists()) {
      if (uvEmpty.style.display == "block") {
        setDisplay(uvEmpty, "none");
      }
      var userWd = data.val();
      addWd(key, userWd, parent, divWds, divWdInfo, btnGoWdRequests);
    }
  });
}
var WD_TMP = `<div class="divWd horizFlex btm-top-gray-border point opas wrap-any">
<div class="horizFlex mainTop">
  <p class="name mainTop">Name</p>
  <p class="uid mainTop">9yyDddfcC4evXFiGajccTJRCOGu1</p>
  <p class="mainTop text-end"><span class="money">0.01</span> <span class="currency">USD</span></p>
</div>
</div>`;
function addWd(key, wd, parent, divWds, divWdInfo, btnGoWdRequests) {
  if (key == null || wd == null) {
    return;
  }
  var oldDiv = document.getElementById(key);
  const container = document.createElement("div");
  container.innerHTML = WD_TMP;
  const divWithdraw = container.firstChild;

  divWithdraw.setAttribute("id", key);

  const elName = divWithdraw.querySelector(".name");
  const elUid = divWithdraw.querySelector(".uid");
  const elMoney = divWithdraw.querySelector("span.money");

  var wdName;
  var wdUid = wd.uid;
  var userRef = firebase.database().ref(`Users/${wdUid}/info/name`);
  userRef.once("value", function (data) {
    if (data.exists()) {
      wdName = data.val() ? data.val() : trans.noName;
      elName.textContent = wdName;
    }
    divWithdraw.addEventListener("click", function () {
      showWdInfo(key, wd, wdName, divWds, divWdInfo, btnGoWdRequests);
    });
  });
  var wdMoney = wd.usd;
  elUid.textContent = wdUid ? wdUid : "";
  elMoney.textContent = wdMoney ? wdMoney : "";

  if (oldDiv) {
    parent.replaceChild(divWithdraw, oldDiv);
  } else {
    parent.appendChild(divWithdraw);
  }
}

function showWdInfo(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
  setDisplay(divWds, "none");
  setDisplay(divWdInfo, "flex");
  setDisplay(btnGoWdReq, "block");

  const divDate = divWdInfo.querySelector(".spWdDate");
  const divUid = divWdInfo.querySelector(".spWdUid");
  const divWdName = document.getElementById("divWdName");
  const divUsd = divWdInfo.querySelector(".spUsd");
  const divRuby = divWdInfo.querySelector(".spRuby");
  const divWdBal = document
    .getElementById("divWdBal")
    .querySelector("span.spBal");
  const methodInfoList = document
    .getElementById("divWdMethod")
    .querySelectorAll("span");
  const btnWdApprove = document.getElementById("btnWdApprove");
  const btnWdDecline = document.getElementById("btnWdDecline");

  divDate.textContent = formatMessageDate(new Date(wd.date), trans.language);
  divUid.textContent = wd.uid;
  divWdName.textContent = wdName;
  divUsd.textContent = wd.usd;
  divRuby.textContent = wd.value;
  divWdBal.textContent = wd.balance;
  methodInfoList[0].textContent = wd.method;
  methodInfoList[1].textContent = wd.methodInfo;
  $(btnWdApprove).unbind();
  $(btnWdDecline).unbind();
  $(btnWdApprove).click(function (e) {
    e.stopPropagation();
    confirmWithdrawDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
  });
  $(btnWdDecline).click(function (e) {
    e.stopPropagation();
    showWdReasonDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
  });
}
function confirmWithdrawDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
  const dialog = document.getElementById("confirmDialog");
  const btnRed = dialog.querySelector(".redBtn");
  const btnBlue = dialog.querySelector(".blueBtn");
  $(btnBlue).unbind();
  $(btnRed).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
    approveWithdraw(key, wd, wdName, divWds, divWdInfo, btnGoWdReq);
  });

  $(btnRed).click(function (e) {
    e.stopPropagation();
    setDisplay(dialog, "none");
  });

  dialog.querySelector("h3 span").textContent = trans.confirmWdNotif;
  dialog.querySelector(".msg").innerHTML = trans.podApprovalMsg;
  setDisplay(dialog, "flex");
}
function showWdReasonDialog(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
  const rDialog = document.getElementById("wdDeclineDialog");
  const btnBlue = rDialog.querySelector(".blueBtn");

  $(btnBlue).unbind();
  $(btnBlue).click(function (e) {
    e.stopPropagation;
    var numReason = wdRad1.checked ? 1 : wdRad2.checked ? 2 : 3;

    if (numReason != 3) {
      setDisplay(rDialog, "none");
      declineWd(
        key,
        wd,
        wdName,
        divWds,
        divWdInfo,
        btnGoWdReq,
        numReason,
        null,
      );
    } else if (wdTaOther.value.trim() != "") {
      setDisplay(rDialog, "none");
      declineWd(
        key,
        wd,
        wdName,
        divWds,
        divWdInfo,
        btnGoWdReq,
        numReason,
        wdTaOther.value.trim(),
      );
    } else {
      $(wdTaOther).shake();
      showToast(trans.provideReason, "toast");
    }
  });

  if (wdName != null) {
    rDialog.querySelector(".note").innerHTML = trans.removalNote.replace(
      "$name",
      wdName,
    );
  } else {
    rDialog.querySelector(".note").innerHTML = "";
  }

  setDisplay(rDialog, "flex");
}
function declineWd(
  key,
  wd,
  wdName,
  divWds,
  divWdInfo,
  btnGoWdReq,
  numReason,
  other,
) {
  progress.querySelector(".message").innerHTML = trans.sendingMessage;
  setDisplay(progress, "flex");
  var alert = {
    date: new Date().getTime(),
    type: "withdrawal",
    reason: 1,
    email: wd.email ? wd.email : null,
    rName: key ? key : null,
    uName: wdName ? wdName : null,
    msg: null,
    sub: trans.wdSubDeclined,
    from: uiName,
    fromId: uid ? uid : null,
  };
  var message = trans.wdAlertMsgDeclined
    .replace("$method", wd.method)
    .replace("$acc", wd.methodInfo)
    .replace("$amount", wd.usd);

  if (other) {
    message = message.replace("$reason", other);
  } else {
    switch (numReason) {
      case 1:
        message = message.replace("$reason", trans.wdR1);
        break;
      case 2:
        message = message.replace("$reason", trans.wdR2);
        break;
      default:
        message = message.replace("$reason", trans.r1);
        break;
    }
  }
  alert.msg = message;

  var verifyRef = firebase.database().ref(`alert/${wd.uid}/${key}`);
  verifyRef.set(alert, function (error) {
    setDisplay(progress, "none");
    if (error) {
      showToast(trans.unknownError, "toast", 2500);
      setDisplay(progress, "none");
    } else {
      //set declined date
      wd.doneDate = alert.date;
      userWdRef.child(`${wd.uid}/${key}`).set(wd, function (error) {
        //remove from wd
        if (error) {
          showToast(trans.unknownError, "toast", 2500);
          setDisplay(progress, "none");
        } else {
          balanceRef.child(`${wd.uid}/ruby`).transaction(
            (current_value) => {
              return (current_value || 0) + wd.value;
            },
            function (error, committed, ss) {
              if (error) {
                showToast(trans.unknownError, "toast", 2500);
                setDisplay(progress, "none");
              } else {
                wdRef.child(key).remove(function (error) {
                  if (error) {
                    showToast(trans.unknownError, "toast", 2500);
                  } else {
                    showToast(trans.messageSent, "toast", 2500);
                  }
                  setDisplay(progress, "none");
                  goToWdReq(divWds, divWdInfo, btnGoWdReq);
                });
              }
            },
          );
        }
      });
    }
  });
}
function approveWithdraw(key, wd, wdName, divWds, divWdInfo, btnGoWdReq) {
  if (key == null) return;
  //save wd key and uid to ref
  progress.querySelector(".message").innerHTML = trans.approvingWd;
  setDisplay(progress, "flex");
  approvedWdRef.child(key).set(wd.uid, function (error) {
    if (error) {
      showToast(trans.unknownError, "toast");
      setDisplay(progress, "none");
    } else {
      //Send alert message to user
      var alert = {
        date: new Date().getTime(),
        type: "withdrawal",
        reason: 0,
        email: wd.email ? wd.email : null,
        rName: key ? key : null,
        uName: wdName ? wdName : null,
        msg: null,
        sub: trans.wdSubApprove,
        from: uiName,
        fromId: uid ? uid : null,
      };
      var message = trans.wdAlertMsgApproved
        .replace("$method", wd.method)
        .replace("$acc", wd.methodInfo)
        .replace("$amount", wd.usd);
      alert.msg = message;

      var verifyRef = firebase.database().ref(`alert/${wd.uid}/${key}`);
      verifyRef.set(alert, function (error) {
        setDisplay(progress, "none");
        if (error) {
          showToast(trans.unknownError, "toast", 2500);
          setDisplay(progress, "none");
        } else {
          //set approved date
          wd.doneDate = alert.date;
          wd.done = true;
          userWdRef.child(`${wd.uid}/${key}`).set(wd, function (error) {
            //remove from wd
            if (error) {
              showToast(trans.unknownError, "toast", 2500);
              setDisplay(progress, "none");
            } else {
              wdRef.child(key).remove(function (error) {
                if (error) {
                  showToast(trans.unknownError, "toast", 2500);
                } else {
                  showToast(trans.confirmSent, "toast", 2500);
                }
                setDisplay(progress, "none");
                goToWdReq(divWds, divWdInfo, btnGoWdReq);
              });
            }
          });
        }
      });
    }
  });
}
function initInAppProducts() {
  searchType = SearchType.purchase;
  //console.log("product=: " + prodApp == null);
  if (prodRef == null) {
    var btnGoProd = document.getElementById("btnGoProd");
    var divProducts = document.getElementById("divProducts");
    const uvEmpty = divProducts.querySelector(".empty");
    const parent = divProducts.querySelector(".coinList");
    var btnAddProd = document.getElementById("btnAddProduct");
    var divCoinPack = document.getElementById("divCoinPack");
    var btnAddCoinPack = document.getElementById("btnAddCoinPack");
    var inSku = document.getElementById("inSku");
    var inValue = document.getElementById("inValue");
    var inPrice = document.getElementById("inPrice");
    prodRef = prodApp.ref("product");
    prodRef.on("child_added", function (data) {
      addCoinList(data.key, data.val(), parent);
    });
    prodRef.on("child_changed", function (data) {
      addCoinList(data.key, data.val(), parent);
    });
    prodRef.on("child_removed", function (data) {
      deleteElement(data.key);
      if (parent.children.length === 0) {
        setDisplay(uvEmpty, "block");
      }
    });
    btnGoProd.addEventListener("click", function () {
      goToProducts(divProducts, divCoinPack, btnGoProd);
    });
    btnAddProd.addEventListener("click", function () {
      setDisplay(divProducts, "none");
      setDisplay(divCoinPack, "flex");
      setDisplay(btnGoProd, "block");
    });
    btnAddCoinPack.addEventListener("click", function () {
      addCoinPack(inSku, inValue, inPrice, divProducts, divCoinPack, btnGoProd);
    });
  }
}
var COIN_TEMP =
  `<div class="divCoin horizFlex btm-top-gray-border">
    <img src="` +
  phCoins +
  `" alt="Coins" class="alt-coins" width="24px">
    <div class="horizFlex mainTop">
      <p class="value mainTop"></p>
      <p class="sku mainTop"></p>
      <p class="cost mainTop text-end">$<span></span></p>
    </div>
  </div>`;
function addCoinList(key, coin, parent) {
  if (key == null || coin == null) {
    return;
  }
  var oldDiv = document.getElementById(key);
  const container = document.createElement("div");
  container.innerHTML = COIN_TEMP;
  const divCoin = container.firstChild;

  divCoin.setAttribute("id", key);

  const elSku = divCoin.querySelector(".sku");
  const elValue = divCoin.querySelector(".value");
  const elCost = divCoin.querySelector(".cost span");

  var coinSku = key;
  var coinValue = coin.value;
  var coinCost = coin.price;

  elSku.textContent = coinSku ? coinSku : trans.noName;
  elValue.textContent = coinValue ? coinValue : "";
  elCost.textContent = coinCost ? coinCost : "";

  if (oldDiv) {
    parent.replaceChild(divCoin, oldDiv);
  } else {
    parent.appendChild(divCoin);
  }
}
function addCoinPack(
  inSku,
  inValue,
  inPrice,
  divProducts,
  divCoinPack,
  btnGoProd,
) {
  var sku = inSku.value.trim();
  var val = inValue.value.trim();
  var price = inPrice.value.trim();
  if (sku == "") {
    $(inSku).shake();
  } else if (val == "") {
    $(inValue).shake();
  } else if (price == "") {
    $(inPrice).shake();
  } else {
    var prodClass = {
      sku: sku,
      value: val,
      price: price,
      uid: uid ? uid : null,
      date: new Date().getTime(),
    };
    prodRef.child(sku).set(prodClass, function (error) {
      if (error) {
        showToast(trans.unknownError, "toast");
      } else {
        showToast(trans.coinAddedSuccess, "toast");
        inSku.value = "";
        inValue.value = "";
        inPrice.value = "";
        goToProducts(divProducts, divCoinPack, btnGoProd);
      }
    });
  }
}
function goToProducts(divProducts, divCoinPack, btnGoProd) {
  setDisplay(divProducts, "flex");
  setDisplay(divCoinPack, "none");
  setDisplay(btnGoProd, "none");
}
function initPods() {
  searchType = SearchType.pod;
  if (uvPodsRef == null) {
    const uvEmpty = podVerify.querySelector(".empty");
    const parent = podVerify.querySelector(".podList");
    uvPodsRef = firebase.database().ref("verify/podcast");
    uvPodsRef.on("child_added", function (data) {
      var podcast = data.val();
      var emptyDisplay = uvEmpty.style.display;
      if (emptyDisplay == "block") {
        setDisplay(uvEmpty, "none");
      }
      addPodcast(data.key, "uv", podcast, parent, false);
    });

    uvPodsRef.on("child_changed", function (data) {
      var podcast = data.val();
      addPodcast(data.key, "uv", podcast, parent, false);
    });
    uvPodsRef.on("child_removed", function (data) {
      deleteElement(data.key + "uv");
      if (parent.children.length === 0) {
        setDisplay(uvEmpty, "block");
      }
    });
  }

  if (vPodsRef == null) {
    const vEmpty = podVerified.querySelector(".empty");
    const parent = podVerified.querySelector(".podList");
    vPodsRef = firebase.database().ref("podcast");
    vPodsRef.on("child_added", function (data) {
      var podcast = data.val();
      var emptyDisplay = vEmpty.style.display;
      if (emptyDisplay == "block") {
        setDisplay(vEmpty, "none");
      }
      addPodcast(data.key, "v", podcast, parent, true);
    });

    vPodsRef.on("child_changed", function (data) {
      var podcast = data.val();
      addPodcast(data.key, "v", podcast, parent, true);
    });
    vPodsRef.on("child_removed", function (data) {
      deleteElement(data.key + "v");
      if (parent.children.length === 0) {
        setDisplay(vEmpty, "block");
      }
    });
  }
}
function addPodcast(key, ext, podcast, parent, verified) {
  if (key == null || podcast == null) {
    return;
  }

  var oldDiv = document.getElementById(key + ext);
  const container = document.createElement("div");
  container.innerHTML = RADIO_TEMPLATE;
  const divPodcast = container.firstChild;

  divPodcast.setAttribute("id", key + ext);

  const elName = divPodcast.querySelector(".name");
  const elTime = divPodcast.querySelector(".time");
  const elLogo = divPodcast.querySelector(".roundImg");

  var podName = podcast.title;
  var podLogo = podcast.icon;
  var time = podcast.date;

  elName.textContent = podName ? podName : trans.noName;
  var creationTime = time
    ? formatMessageDate(new Date(time), trans.language)
    : formatMessageDate(new Date(), trans.language);

  elTime.textContent =
    creationTime == "Today"
      ? trans.today
      : creationTime == "Yesterday"
        ? trans.yesterday
        : creationTime;
  elLogo.src = podLogo ? podLogo : phPodcast;

  var adminName;
  var userRef = firebase.database().ref(`Users/${podcast.uid}/info/name`);
  userRef.once("value", function (data) {
    if (data.exists()) {
      adminName = data.val();
    }
  });
  divPodcast.addEventListener("click", function () {
    initPodContent(key, podcast, verified, adminName);
  });

  if (oldDiv) {
    parent.replaceChild(divPodcast, oldDiv);
  } else {
    const existingPod = parent.children;
    if (existingPod.length === 0) {
      parent.appendChild(divPodcast);
    } else {
      parent.insertBefore(divPodcast, parent.children[0]);
    }
  }
}

function initPodContent(key, podcast, verified, adminName) {
  isMainContent = false;
  iPodContent = podcast;
  iVerified = verified;
  xPodId = key;

  setDisplay(dTestStream, "none");
  setDisplay(mainContent, "none");
  setDisplay(editContent, "flex");
  setDisplay(podContent, "flex");
  setDisplay(radioContent, "none");
  setDisplay(search, "none");
  setDisplay(divResults, "none");
  setDisplay(btnClearSearch, "none");
  if (verified) {
    setDisplay(btnRejectPod, "block");
    setDisplay(btnApprovePod, "none");
    setDisplay(btnUpdatePod, "block");
    setDisplay(dWelcome, "flex");
  } else {
    setDisplay(btnRejectPod, "block");
    setDisplay(btnApprovePod, "block");
    setDisplay(btnUpdatePod, "none");
    setDisplay(dWelcome, "none");
  }
  var email = podcast.email;
  var title = podcast.title;
  var adminName = adminName;
  var uid = podcast.uid;
  var desc = podcast.desc;
  var feed = podcast.feed;
  var lang = podcast.lang;
  var country = podcast.country;
  var genre = podcast.genre;
  var icon = podcast.icon;
  var date = podcast.date;
  var host = podcast.host;

  //optional info
  var web = podcast.web;
  var phone = podcast.phone;
  var podEmail = podcast.pod_email;

  //after verified
  var fb = podcast.fb;
  var tw = podcast.tw;
  var ig = podcast.ig;
  var tk = podcast.tk;
  var yt = podcast.yt;
  var wa = podcast.wa;
  var welcome = podcast.msgWelcome;
  var likes = podcast.likes;
  var revenue = podcast.revenue;
  var screenBlock = podcast.screenBlock;
  var donation = podcast.donation;

  imgPodLogo.src = icon ? icon : phPodcast;
  podAdminId.querySelector("span").textContent = uid ? uid : "";
  inPodAdmin.value = adminName ? adminName : "";
  inHostEmail.value = email ? email : "";
  pPodDate.querySelector("span").textContent = date
    ? formatDate(new Date(date))
    : "";
  pPodId.querySelector("span").textContent = key ? key : "";
  inPodHost.value = host;
  inPodTitle.value = title;
  inFeed.value = feed ? feed : "";
  inPodDesc.value = desc ? desc : "";
  inGenre.value = genre ? genre : "";
  selGenres.selectedIndex = genre ? genre : 0;
  inLang.value = lang ? lang : "";
  selPodLang.selectedIndex = lang ? lang : 12;
  inCountry.value = country ? country : "";
  selPodCountry.selectedIndex = country
    ? getCountryIndex(country.toUpperCase())
    : getCountryIndex("US");

  inPodWeb.value = web ? web : "n/a";
  inPodPhone.value = phone ? phone : "n/a";
  inPodEmail.value = podEmail ? podEmail : "n/a";
  aPodWeb.href = web ? "$start" + web : "javascript:void(0);";
  if (!aPodWeb.href.includes("http")) {
    aPodWeb.href = aPodWeb.href.replace("$start", "http");
  } else {
    aPodWeb.href = aPodWeb.href.replace("$start", "");
  }

  if (podcast.verified) {
    setDisplay(podVerifiedOnly, "flex");
    inPodWelcome.value = welcome ? welcome : "n/a";
    inFb.value = fb;
    inTw.value = tw;
    inIn.value = ig;
    inYt.value = yt;
    inTk.value = tk;
  } else {
    setDisplay(podVerifiedOnly, "flex");
  }

  aFeedUrl.href = feed ? feed : "javascript:void(0);";
  //var isStreamWorking = true;
  // if (feed == null || !feed.includes("https")) {
  //   //load and display iframe
  //   isStreamWorking = false;
  //   initAudioAlert(false);
  // } else {
  //   isStreamWorking = true;
  // }

  //initAudio(nStream);
  initPodAudio(feed);
}

async function initPodAudio(feed) {
  podPlayer.innerHTML = "";
  if (feed) {
    try {
      console.log("initing poa audio");
      //const podcast = await podcastFeedParser.getPodcastFromURL(feed);
      const { podcast, episodes } = await podcastXmlParser(
        new URL(feed),
        config,
      );
      //const episodes = podcast.episodes;
      var episodeLink;
      if (episodes != null && episodes.length > 0) {
        episodeLink = episodes[0].enclosure.url;
      }
      if (episodeLink == null) {
        return;
      }
      var source = document.createElement("source");
      source.src = episodeLink;
      podPlayer.appendChild(source);
      podPlayer.load();
    } catch (error) {
      console.log("could not parse feed", error.message);
    }
  }
}
function initRadios() {
  searchType = SearchType.radio;
  if (uvRadiosRef == null) {
    const uvEmpty = verify.querySelector(".empty");
    const parent = verify.querySelector(".radioList");
    uvRadiosRef = firebase.database().ref("verify/radio");
    uvRadiosRef.on("child_added", function (data) {
      var radio = data.val().info;
      var radioAdmins = data.val().Administrators;
      var dis = uvEmpty.style.display;
      if (dis == "block") {
        setDisplay(uvEmpty, "none");
      }
      addRadio(data.key, "uv", radio, parent, false, radioAdmins);
    });
    uvRadiosRef.on("child_changed", function (data) {
      var radio = data.val().info;
      var radioAdmins = data.val().Administrators;
      addRadio(data.key, "uv", radio, parent, false, radioAdmins);
    });
    uvRadiosRef.on("child_removed", function (data) {
      deleteElement(data.key + "uv");
      if (parent.children.length === 0) {
        setDisplay(uvEmpty, "block");
      }
    });
    clearSearch();
  }

  if (vRadiosRef == null) {
    var parent = verified.querySelector(".radioList");
    vRadiosRef = firebase.database().ref("Radio Stations");
    vRadiosRef.limitToLast(10).on("child_added", function (data) {
      var key = data.key;
      getRadioInfo(key, parent, null);
    });

    vRadiosRef.on("child_removed", function (data) {
      deleteElement(data.key);
      if (parent.children.length === 0) {
        setDisplay(uvEmpty, "block");
      }
    });

    var reviseRef = firebase.database().ref(`checkRadio`);
    var reviseList = reviseRadios.querySelector(".radioCheckList");
    let emptyRevisions = reviseRadios.querySelector(".empty");
    reviseRef.on("child_added", function (data) {
      var key = data.key;
      getRadioInfo(key, reviseList, "check");
      setDisplay(emptyRevisions, "none");
    });

    reviseRef.on("child_removed", function (data) {
      deleteElement(data.key + "check");
      if (parent.children.length === 0) {
        setDisplay(emptyRevisions, "block");
      }
    });
  }
}
function clearSearch() {
  divSearchList.textContent = "";
  setDisplay(divResults, "none");
  setDisplay(pEmpty, "none");
  setDisplay(btnClearSearch, "none");
  inSearch.value = "";
  inSearch.focus();
}
function getRadioInfo(key, parent, ext) {
  var radioInfoRef = firebase.database().ref("Radio Stations/" + key + "/info");
  radioInfoRef.on("value", function (data) {
    if (data.exists()) {
      var radio = data.val();
      addRadio(key, ext, radio, parent, true, null);
    }
  });
}
var RADIO_TEMPLATE =
  '<div class="horizFlex radio opas point">' +
  '<img class="roundImg" src="' +
  phRadioImg +
  '" alt="radio logo" width="40px" height="40px">' +
  '<div class="verticalFlex mainTop" translate="no">' +
  '<div class="name" translate="no"></div>' +
  '<div class="time" translate="no"></div>' +
  "</div>" +
  '<div class="horizFlex vRes">' +
  '<button class="btnEdit" title="Edit"><i class="fas fa-edit"></i><span>Edit</span></button>' +
  '<button class="btnRemove" title="Remove"><i class="fa-solid fa-file-circle-minus"></i><span>Remove</span></button>' +
  "</div>" +
  "</div>";
function addRadio(key, ext, radio, parent, verified, radioAdmins) {
  if (key == null || radio == null) {
    return;
  }

  var oldDiv = document.getElementById(key + ext);
  const container = document.createElement("div");
  container.innerHTML = RADIO_TEMPLATE;
  const divRadio = container.firstChild;

  divRadio.setAttribute("id", key + ext);

  const elName = divRadio.querySelector(".name");
  const elTime = divRadio.querySelector(".time");
  const elLogo = divRadio.querySelector(".roundImg");
  const btnRemove = divRadio.querySelector(".btnRemove");
  const btnEdit = divRadio.querySelector(".btnEdit");

  var radioName = radio.radio_Name;
  var radioLogo = radio.radio_image;
  var time = radio.date_created;

  elName.textContent = radioName ? radioName : trans.noName;
  var creationTime = time
    ? formatMessageDate(new Date(time), trans.language)
    : formatMessageDate(new Date(), trans.language);

  elTime.textContent =
    creationTime == "Today"
      ? trans.today
      : creationTime == "Yesterday"
        ? trans.yesterday
        : creationTime;
  elLogo.src = radioLogo ? radioLogo : phRadioImg;

  divRadio.addEventListener("click", function () {
    fromSearch = ext == "search" || btnClearSearch.style.display == "block";
    initRadioContent(key, radio, verified, radioAdmins);
  });

  if (ext == "check") {
    $(btnRemove).click(function (e) {
      e.stopPropagation();
      removeRevise(key);
    });
  } else {
    setDisplay(btnRemove, "none");
  }
  $(btnEdit).find("span").text(trans.edit);
  $(btnRemove).find("span").text(trans.remove);
  $(btnEdit).attr("title", trans.edit);
  $(btnRemove).attr("title", trans.remove);
  if (oldDiv) {
    parent.replaceChild(divRadio, oldDiv);
  } else {
    const existingRadio = parent.children;
    if (existingRadio.length === 0) {
      parent.appendChild(divRadio);
    } else {
      parent.insertBefore(divRadio, parent.children[0]);
    }
  }
}
function removeRevise(key) {
  var reviseRef = firebase.database().ref(`checkRadio/${key}`);
  reviseRef.remove(function (error) {
    if (error) {
      showToast(trans.unknownError, "toast");
    } else {
      showToast(trans.revisionRemoved, "toast");
    }
  });
}
function deleteElement(id) {
  if (document.getElementById(id)) {
    document.getElementById(id).remove();
  }
}

function initRadioContent(key, radio, verified, radioAdmins) {
  isMainContent = false;
  iRadioInfo = radio;
  iVerified = verified;
  xRadioId = key;
  for (var i in radioAdmins) {
    xRadioAdmin = radioAdmins[i];
  }
  setDisplay(dTestStream, "none");
  setDisplay(mainContent, "none");
  setDisplay(editContent, "flex");
  setDisplay(podContent, "none");
  setDisplay(radioContent, "flex");
  setDisplay(search, "none");
  setDisplay(divResults, "none");
  //setDisplay(btnClearSearch, "none");
  if (verified) {
    setDisplay(btnReject, "block");
    setDisplay(btnApprove, "none");
    setDisplay(btnUpdate, "block");
    setDisplay(dWelcome, "flex");
  } else {
    setDisplay(btnReject, "block");
    setDisplay(btnApprove, "block");
    setDisplay(btnUpdate, "none");
    setDisplay(dWelcome, "none");
  }

  var nAdminId = radio.admin_ID;
  var nAdminName = radio.admin_Name;
  var nRadioName = radio.radio_Name;
  var nSlogan = radio.radio_Slogan;
  var nStream = radio.radio_Stream;
  var nDesc = radio.radio_Description;
  var nRadioId = radio.radio_ID;
  var nLogo = radio.radio_image;
  var nTime = radio.date_created;
  var nBanner = radio.banner;
  var nPhone = radio.phone_no;
  var nLocation = radio.radio_location;
  var nEmail = radio.radio_email;
  var nWeb = radio.website;
  var nWelcome = radio.welcome;
  var nWebStream = radio.webStream;

  pAdminId.textContent = nAdminId ? nAdminId : "";
  inAdminName.value = nAdminName ? nAdminName : "";
  inRadioName.value = nRadioName;
  inSlogan.value = nSlogan ? nSlogan : "";
  inStream.value = nStream ? nStream : "";
  inDesc.value = nDesc ? nDesc : "";
  pRadioId.textContent = nRadioId ? nRadioId : key ? key : "";
  imgLogo.src = nLogo ? nLogo : phRadioImg;
  pRequestDate.textContent = nTime ? formatDate(new Date(nTime)) : "";
  imgBanner.src = nBanner ? nBanner : phBanner;
  inPhone.value = nPhone ? nPhone : "";
  inLocation.value = nLocation ? nLocation : "";
  inEmail.value = nEmail ? nEmail : "";
  inWeb.value = nWeb ? nWeb : "";
  inWelcome.value = nWelcome ? nWelcome : "";
  //btnGoStream.href = nStream ? nStream : "javascript:void(0);";
  var fullWeb = nWeb ? "$start" + nWeb : "javascript:void(0);";
  if (!fullWeb.includes("//")) {
    fullWeb = fullWeb.replace("$start", "//");
  } else {
    fullWeb = fullWeb.replace("$start", "");
  }
  $(btnGoWeb).off("click");
  if (nWeb) {
    $(btnGoWeb).click(function () {
      window.open(fullWeb, "_blank");
    });
  }
  var fullStream = nStream ? "$start" + nStream : "javascript:void(0);";
  if (!fullStream.includes("//")) {
    fullStream = fullStream.replace("$start", "//");
  } else {
    fullStream = fullStream.replace("$start", "");
  }
  $(btnGoStream).off("click");
  if (nStream) {
    $(btnGoStream).click(function () {
      window.open(fullStream, "_blank");
    });
  }
  inWebStream.value = nWebStream ? nWebStream : "";
  var isStreamWorking = true;

  if (nStream == null || !nStream.includes("https")) {
    //load and display iframe
    isStreamWorking = false;
  } else {
    isStreamWorking = true;
  }
  initAudioAlert(false);
  initAudio(nStream);
}
function initSelections() {
  var genres = getGenreList(trans.language);
  if (selGenres.children.length > 0) {
    selGenres.innerHTML = "";
  }
  genres.forEach((genre) => {
    var option = document.createElement("option");
    option.textContent = genre;
    selGenres.appendChild(option);
  });

  var langs = getLangList(trans.language);
  if (selPodLang.children.length > 0) {
    selPodLang.innerHTML = "";
  }
  langs.forEach((lng) => {
    var option = document.createElement("option");
    option.textContent = lng;
    selPodLang.appendChild(option);
  });

  var countryList = getCountryList(trans.language);
  if (selPodCountry.children.length > 0) {
    selPodCountry.innerHTML = "";
  }
  countryList.forEach((c) => {
    var option = document.createElement("option");
    option.textContent = c;
    selPodCountry.appendChild(option);
  });
}
function formatDate(date) {
  var nDate = formatMessageDate(date, trans.language);
  var nTime = formatTime(date);
  var xTime;
  switch (nTime) {
    case "Today":
      xTime = trans.today;
      break;
    case "Yesterday":
      xTime = trans.yesterday;
      break;
    default:
      xTime = nTime;
      break;
  }
  return nDate + " (" + xTime + ")";
}

function initAudio(nStream) {
  elAudio.innerHTML = "";
  if (nStream) {
    var source = document.createElement("source");
    source.src = nStream;
    elAudio.appendChild(source);
    var backupSource = document.createElement("source");
    var backUpUrl;
    if (nStream.endsWith("/")) {
      backUpUrl = nStream + ";";
    } else if (nStream.endsWith("/;")) {
      //backupSource.src = radioStream;
      backUpUrl = nStream;
    } else {
      //backupSource.src = radioStream + "/;";
      backUpUrl = nStream + "/;";
    }

    backupSource.src = backUpUrl;
    elAudio.appendChild(backupSource);
    elAudio.load();
  }
}

function initUsers() {}
searchType = SearchType.users;
jQuery.fn.shake = function (intShakes, intDistance, intDuration) {
  intShakes = intShakes || 4;
  intDistance = intDistance || 2;
  intDuration = intDuration || 500;

  this.each(function () {
    $(this).css("position", "relative");
    for (var x = 1; x <= intShakes; x++) {
      $(this)
        .animate({ left: intDistance * -1 }, intDuration / intShakes / 4)
        .animate({ left: intDistance }, intDuration / intShakes / 2)
        .animate({ left: 0 }, intDuration / intShakes / 4);
    }
  });
  return this;
};

var language = {
  eng: {
    language: "en",
    appSum: "App summary",
    radioStations: "Radio stations",
    registeredUsers: "Registered users",
    translate: "Translate",
    unverifiedRadios: "Unverified radios",
    verifiedRadios: "Verified radios",
    totalUsers: "Total users",
    latestVersion: "Latest version",
    contactInfo: "Contact information",
    linksToShare: "Links to share",
    mainWebsite: "Main website",
    googlePlayStore: "Google Play Store",
    shortLink: "Short link",
    noVerification: "No radio station needs verification at this time",
    recentVerifiedRadios: "Recently verified radios",
    uploadingInfo: "Uploading information",
    copy: "Copy",
    search: "Search",
    addContactEmail: "Add my contact email",
    hideNavMenu: "Hide navigation menu",
    showNavMenu: "Show navigation menu",
    noRecentRadios: "No radio stations added recently",
    noName: "No name provided",
    notFound: "was not found",
    scrollUnverified: "Scroll to unverified radios",
    scrollToVerified: "Scroll to verified radios",
    requestingInfo: "Requesting information",
    signingIn: "Signing in",
    verifyingInfo: "Verifying information",
    loadingData: "Loading data",
    login: "Login",
    logIn: "Log in",
    email: "Email",
    password: "Password",
    permissionDenied: "You do not have permission to view this content",
    invalidPassword: "Invalid password",
    invalidEmail: "Invalid email",
    userDisabled: "This account is disabled",
    userNotFound: "The account was not found",
    unknownError: "Unknown error. Please try again later",
    logout: "Logout",
    confirmLogout: "Are you sure you want to logout?",
    close: "Close",
    signOut: "Sign out",
    signingOut: "Signing out",
    slogan: "Slogan",
    description: "Description",
    name: "Name",
    logo: "Logo",
    banner: "Banner",
    streamUrl: "Stream URL",
    location: "Location",
    phone: "Phone",
    website: "Website",
    audioWorking: "Is the audio working?",
    errorAudio: "The audio could not played",
    requestInfo: "Request information",
    removeRadio: "Remove radio",
    approveRadio: "Approve radio",
    updateRadio: "Update radio",
    unsecureUrl: "The radio stream is unsecure (http)",
    errorPlay: "The radio stream could not be loaded",
    successPlay: "The radio stream played successfully",
    testNewStream: "Test a different stream url:",
    test: "Test",
    visitStream: "Visit stream url",
    visitWeb: "Visit website",
    adminInfo: "Admin information",
    adminId: "Admin id",
    requestDate: "Request date",
    radioInfo: "Radio information",
    radioId: "Radio id",
    back: "Back",
    webStream: "Web Streaming URL",
    welcomeMsg: "Welcome message",
    today: "Today",
    yesterday: "Yesterday",
    welcome: "👋 Welcome $name 👋",
    sendMsg: "Send message",
    undo: "Undo",
    cancel: "Cancel",
    delete: "Delete",
    yes: "Yes",
    no: "No",
    selectReason: "Select reason",
    rmnMessage:
      "Thank you for submitting your station, <b>$name</b>. Unfortunately, we were unable to add your station to ChatMurcianys for this reason:<br><br>",
    r1: "Invalid/incomplete information",
    m1: "The information you provided could not be verified.",
    r2: "Invalid streaming URL",
    m2: "The streaming URL provided is not working.",
    r3: "Policy violation",
    m3: 'The station violates ChatMurcianys guidelines. Visit <a target="_blank" href="https://chatmurcianys.com/about#privacy">https://chatmurcianys.com/about#privacy</a> for more information.',
    other: "Other",
    m4: "We are contacting you for the following reason:",
    updateRadioInfo:
      'You may update your station by visiting <a target="_blank" href="https://chatmurcianys.com/chat/#r=$id">chatmurcianys.com/chat/#r=$id</a> or using the ChatMurcianys app and going to "My radios"',
    reSubmitRadio:
      "You may re-submit your station by visiting chatmurcianys.com/addRadio or using our app, ChatMurcianys, on the Google Play Store.",
    sub1: "$name approval|ChatMurcianys",
    sub2: "$name submission incomplete|ChatMurcianys",
    sub3: "$name Submission response|ChatMurcianys",
    sub4: "$name Important Information|ChatMurcianys",
    confirmRemoval: "Confirm removal",
    confirmRemovalMsg: "Are you sure you want to remove $name?",
    concludeMsg:
      "If you have any questions, feel free to respond to this email: info@chatmurcianys.com",
    removalNote: "This information will be made known to <b>$name</b>",
    removingRadio: "Removing radio",
    sendingConfirmation: "Sending confirmation",
    radioRemoved: "Radio removed successfully",
    confirmApprove: "Confirmar aprovación",
    approvalMsg:
      'If all the radio station information is accurate, click "Continue"',
    continue: "Continue",
    radioApproved: "The radio was approved successfully",
    errorMissingInfo: "The radio information is incomplete",
    approveEmail:
      "Congratulations! Your radio station, <b>$name</b>, was approved." +
      "$urlSsl" +
      '<br><br>Use this link to share with your audience and on social media:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/r=$wName">chatmurcianys.com/chat/r=$wName</a>' +
      "<br><br>To increase and keep the visibility of your station on ChatMurcianys, we encourage you to share the link we have provided. " +
      "This way you help us keep our services free and bring better things in the future. " +
      'For more information on how to keep your radio station active in ChatMurcianys, visit <a target="_blank" href="https://chatmurcianys.com/about#station">chatmurcianys.com/chat/about#station</a>' +
      "<br><br>¡Welcome to ChatMurcianys!",
    verifyingRadioInfo: "Verifying radio information",
    urlUnsecureMsg:
      " However, while your radio station's streaming URL is working, the stream is unsecure (http). Because of this, some browsers like Chrome will not play your radio on secured sites (https) like ChatMurcianys.com." +
      'In order for your radio to play, you would need to allow unsecured content for ChatMurcianys.com. Chrome users can <a target="_blank" href="https://www.youtube.com/watch?v=v_h0V3NYOGo">watch this video to learn how.</a>' +
      "Another option would be to contact your provider and request a secured streaming url.",
    removingImages: "Removing images",
    removingChat: "Removing chat room",
    errorChat: "Chat room was not found",
    sendingMessage: "Sending message",
    messageSent: "Menssage sent successfully",
    writeMsgHere: "Write your message here...",
    provideReason: "Provide a reason",
    podcasts: "Podcasts",
    podcast: "Podcast",
    unverifiedPods: "Unverified podcasts",
    noPodVerifications: "No podcast needs verification at this time",
    recentVerifiedPods: "Recently verified podcasts",
    noRecentPods: "No podcasts added recently",
    remove: "Remove",
    update: "Update",
    approve: "Approve",
    sendMessage: "Send message",
    podcastInfo: "Podcast information",
    title: "Title",
    podId: "Id del podcast",
    feedURL: "Feed URL",
    genre: "Genre",
    lang: "Language",
    webPage: "Web page",
    phone_no: "Phone number",
    country: "Country",
    optionalInfo: "Optional information",
    tkLink: "TikTok link",
    ytLink: "YouTube link",
    inLink: "Instagram link",
    twLink: "Twitter link",
    fbLink: "Facebook link",
    addWelcomeMsg: "Add a welcome message",
    verifiedPodcast: "Verified podcast",
    invalidFeed: "Invalid feed",
    removingPod: "Removing podcast",
    m2Pod: "The feed URL provided is not working.",
    m3Pod:
      "The podcast violates ChatMurcianys guidelines. Visit https://chatmurcianys.com/about#privacy for more information.",
    updatePodInfo:
      'You may update your podcast by visiting <a target="_blank" href="https://chatmurcianys.com/chat/#p=$id">chatmurcianys.com/chat/#p=$id</a> or using the ChatMurcianys app and going to "My groups"',
    reSubmitPod:
      "You may re-submit your podcast by visiting chatmurcianys.com/addPodcast or using our app, ChatMurcianys, on the Google Play Store.",
    podRemoved: "Podcast removed successfully",
    podApproved: "The podcast was approved successfully",
    errorPodMissingInfo: "Podcast information is incomplete",
    podApprovalMsg:
      'If all the podcast information is accurate, click "Continue"',
    verifyingPodInfo: "Verifying podcast information",
    approvePodEmail:
      "Congratulations! Your podcast, <b>$name</b>, was approved." +
      "$urlSsl" +
      '<br><br>Use this link to share with your audience and on social media:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/p=$wName">chatmurcianys.com/chat/p=$wName</a>' +
      "<br><br>To increase and keep the visibility of your podcast on ChatMurcianys, we encourage you to share the link we have provided. " +
      "This way you help us keep our services free and bring better things in the future. " +
      'For more information on how to keep your podcast active in ChatMurcianys, visit <a target="_blank" href="https://chatmurcianys.com/about#podcast">chatmurcianys.com/about#podcast</a>' +
      "<br><br>¡Welcome to ChatMurcianys!",
    errorPodNameExists: "The podcast's name is already in use",
    errorFeedExists: "This podcast feed is already registered",
    host: "Host",
    inAppPurchases: "In-app purchases",
    products: "Products",
    noProducts: "No products available at this time",
    coins: "Coins",
    value: "Value",
    id: "Id",
    cost: "Cost",
    addCoinPack: "Add coin pack",
    coinPack: "Coin pack",
    coinAddedSuccess: "Coin added succesfully",
    wdRequests: "Withdrawal requests",
    wds: "Withdrawals",
    noWds: "No withdrawal requests available at this time",
    amount: "Amount",
    wdRequestInfo: "Withdrawal request information",
    date: "Date:",
    reqAmount: "Requested amount",
    initBal: "Initial balance",
    payMethod: "Payout method",
    decline: "Decline",
    approvingWd: "Sending withdrawal approval confirmation",
    confirmSent: "Confirmation sent",
    wdSubApprove: "Withdrawal approval | ChatMurcianys",
    wdSubDeclined: "Withdrawal declined | ChatMurcianys",
    wdAlertMsgApproved: `Your withdrawal request was approved. We have sent the amount requested to the acccount you provided with the following information:<br><ul><li>Method: $method</li><li>Account: $acc</li><li>Amount: $amount USD</li></ul><br>Depending on the payout provider, it may take a while to receive your money. Please allow at least 21 days for the funds to transfer into your account. If you still don't receive your payment, contact us at info@chatmurcianys.com`,
    wdR1: `We could not verify the payout account`,
    wdR2: `The amount requested is greater than the account balance`,
    wdAlertMsgDeclined: `We could not complete your withdrawal request:<br><ul><li>Method: $method</li><li>Account: $acc</li><li>Amount: $amount USD</li></ul><br>Your request was rejected because:<br>$reason<br>If your withdrawal complies with our Policies, you will receive the requested withdrawal amount in Rubies to your ChatMurcianys account balance.<br>For more information, contact us at info@chatmurcianys.com or visit <a href="https://chatmurcianys.com/about#withdrawal-policy">chatmurcianys.com/about#withdrawal-policy</a>`,
    confirmMsg: `If all information is accurate, click "Continue"`,
    confirmWdNotif: `Confirm withdrawal approval`,
    clearSearch: "Clear search",
    searchWait: "Searching...please wait",
    viewAll: "View all",
    errorRadioNameTaken: "Radio name is not available",
    errorRadioStreamTaken: "Radio streaming URL is not available",
    successUpdate: "Information updated successfully",
    markRevision: "Mark for revision",
    successRevision: "Marked for revision",
    addingRevision: "Adding for revision",
    needRevision: "In need of revision",
    noRevisions: "No revisions needed at this time",
    edit: "Edit",
    revisionRemoved: "Removed from revisions",
  },
  es: {
    language: "es",
    appSum: "Resumen de la aplicación",
    radioStations: "Estaciones de radio",
    registeredUsers: "Usuarios registrados",
    translate: "Traducir",
    unverifiedRadios: "Radios no verificadas",
    verifiedRadios: "Radios verificadas",
    totalUsers: "Total de usuarios",
    latestVersion: "Versión actual",
    contactInfo: "Información de contacto",
    linksToShare: "Enlaces para compartir",
    mainWebsite: "Sitio web principal",
    googlePlayStore: "Tienda de Google Play",
    shortLink: "Enlace corto",
    noVerification:
      "Ninguna estación de radio necesita verificación en este momento",
    recentVerifiedRadios: "Radios verificadas recientemente",
    uploadingInfo: "Subiendo información",
    copy: "Copiar",
    search: "Buscar",
    addContactEmail: "Añadir mi correo electrónico",
    hideNavMenu: "Ocultar menú de navegación",
    showNavMenu: "Mostrar menú de navegación",
    noRecentRadios: "No se agregaron estaciones de radio recientemente",
    noName: "Nombre no proporcionado",
    notFound: "No fue encontrado",
    scrollUnverified: "Ir a radios no verificadas",
    scrollToVerified: "Ir a radios verificadas",
    requestingInfo: "Solicitando información",
    signingIn: "Iniciando sesión",
    verifyingInfo: "Verificando información",
    loadingData: "Bajando información",
    login: "Entrar al sistema",
    logIn: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    permissionDenied: "No tienes permiso de ver este contenido",
    invalidPassword: "La contraseña es invalida",
    invalidEmail: "El correo electrónico es invalido",
    userDisabled: "La cuenta está deshabilitada",
    userNotFound: "La cuenta no se encontró",
    unknownError: "Error desconocido. Por favor vuelve a intentarlo más tarde",
    logout: "Cerrar sesión",
    confirmLogout: "¿Quieres cerrar sesión?",
    close: "Cerrar",
    signOut: "Cerrar sesión",
    signingOut: "Cerrando sesión",
    slogan: "Eslogan",
    description: "Descripción",
    name: "Nombre",
    logo: "Logotipo",
    banner: "Bandera",
    streamUrl: "URL de transmisión de radio",
    location: "Ubicación",
    phone: "Teléfono",
    website: "Sitio web",
    audioWorking: "¿Esta funcionando la radio?",
    errorAudio: "El audio no se pudo reproducir",
    requestInfo: "Solicitar información",
    removeRadio: "Remover radio",
    approveRadio: "Aprobar radio",
    updateRadio: "Actualizar radio",
    unsecureUrl: "URL de transmisión no es seguro (http)",
    errorPlay: "El URL de transmisión no se pudo reproducir",
    successPlay: "URL de transmisión se repodució con éxito",
    testNewStream: "Prueba un URL de transmisión diferente:",
    test: "Probar",
    visitStream: "Visitar URL de transmisión",
    visitWeb: "Visitar sitio web",
    adminInfo: "Información de administrador",
    adminId: "Id de administrador",
    requestDate: "Fecha de solicitud",
    radioInfo: "Información de la radio",
    radioId: "Id de la radio",
    back: "Regresar",
    webStream: "Sitio web URL de transmisión",
    welcomeMsg: "Mensaje de bienvenida",
    today: "Hoy",
    yesterday: "Ayer",
    welcome: "👋Bienvenid@ $name 👋",
    sendMsg: "Enviar mensaje",
    undo: "Revertir",
    cancel: "Cancelar",
    delete: "Borrar",
    yes: "Si",
    no: "No",
    selectReason: "Seleccionar motivo",
    rmnMessage:
      "Gracias por someter tu estación, <b>$name</b>. Desafortunadamente, no pudimos agregar tu estación a ChatMurcianys por esta razón:<br><br>",
    r1: "Información invalida/incompleta",
    m1: "La información sometida no se pudo verificar.",
    r2: "El URL de transmisión no es valido",
    m2: "El URL de transmisión no se pudo reproducir",
    r3: "Violación de la política",
    m3: 'La estación viola las reglas de ChatMurcianys. Visite <a target="_blank" href="https://chatmurcianys.com/about#privacy">https://chatmurcianys.com/about#privacy</a> para obtener más información.',
    other: "Otra",
    m4: "Te estamos contactando por la siguiente razón:",
    updateRadioInfo:
      'Puedes actualizar tu estación visitando <a target="_blank" href="https://chatmurcianys.com/chat/#r=$id">chatmurcianys.com/chat/#r=$id</a> o usando la aplicación ChatMurcianys y yendo a "Mis radios"',
    reSubmitRadio:
      "Puedes volver a someter tu estación visitando chatmurcianys.com/addRadio o usando nuestra aplicación, ChatMurcianys, en Google Play Store.",
    sub1: "$name aprobación|ChatMurcianys",
    sub2: "$name Información incompleta|ChatMurcianys",
    sub3: "$name Respuesta de la registración|ChatMurcianys",
    sub4: "$name Información Importante|ChatMurcianys",
    confirmRemoval: "Confirmar eliminación",
    confirmRemovalMsg: "Quieres remover a <b>$name</b>?",
    concludeMsg:
      "Si tienes alguna pregunta, no dudes en responder a este correo: info@chatmurcianys.com",
    removalNote: "Esta información se le hara saber a <b>$name</b>",
    removingRadio: "Removiendo la radio",
    sendingConfirmation: "Enviando confirmación",
    radioRemoved: "La radio fue removida con éxito",
    confirmApprove: "Confirmar aprovación",
    approvalMsg:
      'Si toda la información de la radio está correcta, presióna "Continuar"',
    continue: "Continuar",
    radioApproved: "La radio fue aprovada con éxito",
    errorMissingInfo: "La información de la radio está incompleta",
    approveEmail:
      "¡Felicidades! Tu estación de radio, <b>$name</b>, fue aprovada." +
      "$urlSsl" +
      '<br><br>Usa este enlace para compartir con tus oyentes y en las redes sociales:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/r=$wName">chatmurcianys.com/chat/r=$wName</a>' +
      "<br><br>Para aumentar y mantener la visibilidad de tu radio en ChatMurcianys, te recomendamos que compartas el enlace que hemos proveido. " +
      "De esta manera nos ayudas a mantener nuestros servicios gratis y traer mejores cosas a futuro. " +
      'Para más información sobre como mantener tu radio activa en ChatMurcianys, visita <a target="_blank" href="https://chatmurcianys.com/about#station">chatmurcianys.com/chat/about#station</a>' +
      "<br><br>¡Bievenid@ a ChatMurcianys!",
    verifyingRadioInfo: "Verificando información de la radio",
    urlUnsecureMsg:
      " Sin embargo, aunque el URL de transmisión de la radio es valida, la transmisión no es segura (http). Debido a esto, algunos navegadores como Chrome no reproducirán tu radio en sitios seguros (https) como ChatMurcianys.com." +
      'Para que tu radio se pueda escuchar, necesitas permitir contenido no seguro para ChatMurcianys.com. Los usuarios de Chrome pueden <a target="_blank" href="https://www.youtube.com/watch?v=v_h0V3NYOGo">mirar este video para aprender como.</a>' +
      "Otra opción sería que contáctes a tu proveedor y solicitar una URL de transmisión segura (https).",
    removingImages: "Removiendo las imágenes",
    removingChat: "Removiendo la sala de chat",
    errorChat: "No se encontró la sala de chat",
    sendingMessage: "Enviando mensaje",
    messageSent: "Mensaje enviado con éxito",
    writeMsgHere: "Escribe tu mensaje aquí...",
    provideReason: "Provee una razón",
    podcasts: "Podcasts",
    podcast: "Podcast",
    unverifiedPods: "Podcasts no verificadas",
    noPodVerifications: "Ningún podcast necesita verificación en este momento",
    recentVerifiedPods: "Podcasts recientemente verificadas",
    noRecentPods: "No se agregaron podcasts recientemente",
    remove: "Remover",
    update: "Actualizar",
    approve: "Aprobar",
    sendMessage: "Enviar mensaje",
    podcastInfo: "Información del podcast",
    title: "Título",
    podId: "Podcast Id",
    feedURL: "Enlace de fuente",
    genre: "Género",
    lang: "Idioma",
    webPage: "Página web",
    phone_no: "Número de teléfono",
    country: "País",
    optionalInfo: "Información opcional",
    tkLink: "Enlace de TikTok",
    ytLink: "Enlace de YouTube",
    inLink: "Enlace de Instagram",
    twLink: "Enlace de Twitter",
    fbLink: "Enlace de Facebook",
    addWelcomeMsg: "Agregar mensaje de bienvenida",
    verifiedPodcast: "Podcasts verificados",
    invalidFeed: "Enlace de fuente invalido",
    removingPod: "Removiendo podcast",
    m2Pod: "El enlace de la fuente de transmisión no se pudo reproducir",
    m3Pod:
      'La estación viola las reglas de ChatMurcianys. Visite <a target="_blank" href="https://chatmurcianys.com/about#privacy" para obtener más información.',
    updatePodInfo:
      'Puedes actualizar tu podcast visitando <a target="_blank" href="https://chatmurcianys.com/chat/#p=$id">chatmurcianys.com/chat/#p=$id</a> o usando la aplicación ChatMurcianys y yendo a "Mis grupos"',
    reSubmitPod:
      "Puedes volver a someter tu estación visitando chatmurcianys.com/addPodcast o usando nuestra aplicación, ChatMurcianys, en Google Play Store.",
    podRemoved: "El podcast fue removido con éxito",
    podApproved: "El podcast fue aprovada con éxito",
    errorPodMissingInfo: "La información del podcast está incompleta",
    podApprovalMsg:
      'Si toda la información del podcast está correcta, presióna "Continuar"',
    verifyingPodInfo: "Verificando información del podcast",
    approvePodEmail:
      "¡Felicidades! Tu podcast, <b>$name</b>, fue aprovada." +
      "$urlSsl" +
      '<br><br>Usa este enlace para compartir con tus oyentes y en las redes sociales:<br><br><a target="_blank" href="https://chatmurcianys.com/chat/p=$wName">chatmurcianys.com/chat/p=$wName</a>' +
      "<br><br>Para aumentar y mantener la visibilidad de tu podcast en ChatMurcianys, te recomendamos que compartas el enlace que hemos proveido. " +
      "De esta manera nos ayudas a mantener nuestros servicios gratis y traer mejores cosas a futuro. " +
      'Para más información sobre como mantener tu podcast activo en ChatMurcianys, visita <a target="_blank" href="https://chatmurcianys.com/about#podcast">chatmurcianys.com/about#podcast</a>' +
      "<br><br>¡Bievenid@ a ChatMurcianys!",
    errorPodNameExists: "El nombre del podcast ya esta en uso",
    errorFeedExists: "Esta fuente del podcast ya está registrada",
    host: "Locutor",
    inAppPurchases: "Compras en la aplicación",
    products: "Productos",
    noProducts: "No hay productos disponibles en este momento",
    coins: "Monedas",
    value: "Valor",
    id: "Id",
    cost: "Precio",
    addCoinPack: "Agregar paquete de monedas",
    coinPack: "Paquete de moneda",
    coinAddedSuccess: "Moneda agregada con éxito",
    wdRequests: "Solicitudes de retiro",
    wds: "Retiros",
    noWds: "No hay solicitudes de retiro en este momento",
    amount: "Cantidad",
    wdRequestInfo: "Información de solicitud de retiro",
    date: "Fecha:",
    reqAmount: "Cantidad solicitada:",
    initBal: "Balance inicial",
    payMethod: "Método de pago",
    decline: "Declinar",
    approvingWd: "Enviando confirmación de aprobación de retiro",
    confirmSent: "Confirmación enviada",
    wdSubApprove: "Aprobación de retiro | ChatMurcianys",
    wdSubDeclined: "Retiro declinado | ChatMurcianys",
    wdAlertMsgApproved:
      "Tu solicitud de retiro fue aprobada. Hemos enviado el monto solicitado a la cuenta proporcionada con la siguiente información:<br><ul><li>Método: $method</li><li>Cuenta: $acc</li><li>Cantidad: $amount USD</li></ul><br>Dependiendo del proveedor de pago, puede tomar un tiempo recibir tu dinero. Espera al menos 21 días para que los fondos se transfieran a tu cuenta. Si aún no recibes tu pago, contáctanos en info@chatmurcianys.com",
    wdR1: `No pudimos verificar la cuenta de pago`,
    wdR2: `La cantidad solicitada es mayor que el balance de la cuenta`,
    wdAlertMsgDeclined: `No pudimos completar tu solicitud de retiro:<br><ul><li>Método: $method</li><li>Cuenta: $acc</li><li>Cantidad: $amount USD</li></ ul><br>Tu solicitud fue rechazada porque:<br>$reason<br>Si tu retiro cumple con nuestras Políticas, recibirá el monto del retiro solicitado en Rubíes en el saldo de tu cuenta de ChatMurcianys.<br>Para obtener más información, contáctanos en info@chatmurcianys.com o visita <a href="https://chatmurcianys.com/about#withdrawal-policy">chatmurcianys.com/sobre#politica-de-retiros</a>`,
    confirmMsg: `Si toda la información está correcta, presióna "Continuar"`,
    confirmWdNotif: `Confirmar aprobación de retiro`,
    clearSearch: "Borrar búsqueda",
    searchWait: "Buscando...por favor espere",
    viewAll: "Ver todos",
    errorRadioNameTaken: "El nombre de la radio no está disponible",
    errorRadioStreamTaken: "El URL de transmisión de radio no está disponible",
    successUpdate: "Información actualizada con éxito",
    markRevision: "Marcar para revisión",
    successRevision: "Marcado para revisión",
    addingRevision: "Agregando para revisar",
    needRevision: "Necesitan revisión",
    noRevisions: "No se necesitan revisiones en este momento",
    edit: "Editar",
    revisionRemoved: "Removido de revisiones",
  },
};

function translatePage(lang) {
  var translate = false;
  if (lang) {
    translate = true;
    if (lang.includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      aEn.className = aEn.className.replace("selected", "");
      aEs.className += "selected";
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
      document.getElementsByTagName("html")[0].setAttribute("lang", "en");
      aEs.className = aEn.className.replace("selected", "");
      aEn.className += "selected";
      setCookie("lang", "en", 365);
    }
  } else if (getCookie("lang") != "") {
    if (getCookie("lang").includes("es")) {
      trans = language.es;
      document.getElementsByTagName("html")[0].setAttribute("lang", "es");
      var langs = langDropdown.querySelectorAll("a");
      langs[0].className = langs[0].className.replace("selected", "");
      langs[1].className += "selected";
      translate = true;
      setCookie("lang", "es", 365);
    } else {
      trans = language.eng;
    }
  } else if (
    window.navigator.language &&
    window.navigator.language.includes("es")
  ) {
    translate = true;
    trans = language.es;
    document.getElementsByTagName("html")[0].setAttribute("lang", "es");
    aEn.className = aEn.className.replace(" selected", "");
    aEs.className += " selected";
  } else {
    trans = language.eng;
  }

  if (translate) {
    $(".copy").attr("title", trans.copy);
    //var navs = navList.querySelectorAll('a .title')
    navTitles[0].textContent = trans.appSum;
    navTitles[1].textContent = trans.radioStations;
    navTitles[2].textContent = trans.registeredUsers;
    navTitles[3].textContent = trans.podcasts;
    navTitles[4].textContent = trans.inAppPurchases;
    navTitles[5].textContent = trans.wds;
    aTranslate.querySelector(".title").textContent = trans.translate;
    navContent.querySelector("h2").textContent = mainNav
      ? navs[mainNav].textContent
      : trans.appSum;
    search.querySelector("input").placeholder = trans.search;
    btnSearch.title = trans.search;
    btnClearSearch.title = trans.clearSearch;
    btnClearSearch.querySelector("span").textContent = trans.clearSearch;
    unverifiedTotal.querySelector("h3").textContent = trans.unverifiedRadios;
    radioTotal.querySelector("h3").textContent = trans.verifiedRadios;
    userTotal.querySelector("h3").textContent = trans.totalUsers;
    appInfo.querySelector("h3").textContent = trans.latestVersion;
    unverifiedPodTotal.querySelector("h3").textContent = trans.unverifiedPods;
    podTotal.querySelector("h3").textContent = trans.verifiedPodcast;
    contact.querySelector("h3").textContent = trans.contactInfo;
    btnAddEmail.querySelector("span").textContent = trans.addContactEmail;
    links.querySelector("h3").textContent = trans.linksToShare;
    var linkPs = links.querySelectorAll("p");
    linkPs[0].textContent = trans.mainWebsite;
    linkPs[1].textContent = trans.googlePlayStore;
    linkPs[2].textContent = trans.shortLink;
    verify.querySelector("h3 span").textContent = trans.unverifiedRadios;
    verify.querySelector(".empty span").textContent = trans.noVerification;
    reviseRadios.querySelector("h3 span").textContent = trans.needRevision;
    reviseRadios.querySelector(".empty span").textContent = trans.noRevisions;
    verified.querySelector("h3 span").textContent = trans.recentVerifiedRadios;
    verified.querySelector(".empty span").textContent = trans.noRecentRadios;
    progress.querySelector(".message").textContent = trans.uploadingInfo;
    var navDisplay = nav.style.display;
    if (window.innerWidth <= 840) {
      if (navDisplay == "" || navDisplay == "none") {
        btnToggleNav.title = trans.showNavMenu;
      } else {
        btnToggleNav.title = trans.hideNavMenu;
      }
    } else {
      if (navDisplay == "" || navDisplay == "flex") {
        btnToggleNav.title = trans.hideNavMenu;
      } else {
        btnToggleNav.title = trans.showNavMenu;
      }
    }

    var scrollButtons = inScroll.querySelectorAll("button");
    scrollButtons[0].title = trans.scrollUnverified;
    scrollButtons[1].title = trans.scrollToVerified;
    var inputs = login.querySelectorAll("input");
    inputs[0].placeholder = trans.email;
    inputs[1].placeholder = trans.password;
    login.querySelectorAll("h3 span").textContent = trans.login;
    login.querySelector("button").textContent = trans.logIn;
    $(".btn-close").attr("title", trans.close);
    signout.querySelector("h3 span").textContent = trans.confirmLogout;
    signout.querySelector(".btn-blue").textContent = trans.logout;
    btnLogout.querySelector("span").textContent = trans.signOut;
    imgLogo.alt = trans.logo;
    imgBanner.alt = trans.banner;
    lblRadioName.textContent = trans.name + ":";
    inRadioName.placeholder = trans.name;
    lblSlogan.textContent = trans.slogan + ":";
    inSlogan.placeholder = trans.slogan;
    lblDesc.textContent = trans.description + ":";
    inDesc.placeholder = trans.description;
    lblStream.textContent = trans.streamUrl + ":";
    inStream.placeholder = trans.streamUrl;
    lblAudio.textContent = trans.audioWorking;
    //audioAlert
    lblLocation.textContent = trans.location + ":";
    inLocation.placeholder = trans.location;
    lblEmail.textContent = trans.email + ":";
    inEmail.placeholder = trans.email;
    lblPhone.textContent = trans.phone + ":";
    inPhone.placeholder = trans.phone;
    lblWeb.textContent = trans.website + ":";
    inWeb.placeholder = trans.website;
    btnRequestInfo.querySelector("span").textContent = trans.sendMsg;
    btnReject.querySelector("span").textContent = trans.removeRadio;
    btnApprove.querySelector("span").textContent = trans.approveRadio;
    btnUpdate.querySelector("span").textContent = trans.updateRadio;
    btnGoStream.textContent = trans.visitStream;
    btnGoWeb.textContent = trans.visitWeb;
    adminInfo.querySelector("h3 span").textContent = trans.adminInfo;
    radioInfo.querySelector("h3 span").textContent = trans.radioInfo;
    iRadioId.textContent = trans.radioId + ": ";
    iRequestDate.textContent = trans.requestDate + ": ";
    iAdminId.textContent = trans.adminId + ": ";
    btnBack.title = trans.back;
    lblWebStream.textContent = trans.webStream + ":";
    lblAdminName.textContent = trans.name + ":";
    lblWelcome.textContent = trans.welcomeMsg + ":";
    inAdminName.placeholder = trans.name;
    inWelcome.placeholder = trans.welcome;
    inWebStream.placeholder = trans.webStream;
    lblTestUrl.textContent = trans.testNewStream;
    btnTestUrl.textContent = trans.test;
    pAudioAlert.textContent = trans.errorAudio;
    $(".undo").attr("title", trans.undo);
    reasonDialog.querySelector(".blueBtn").textContent = trans.continue;
    var lReasons = reasonDialog.querySelectorAll("label");
    lReasons[0].textContent = trans.r1;
    lReasons[1].textContent = trans.r2;
    lReasons[2].textContent = trans.r3;
    lReasons[3].textContent = trans.other;
    reasonDialog.querySelector("h3").textContent = trans.selectReason;
    taOther.placeholder = trans.writeMsgHere;
    $(".tc-write-msg-here").attr("placeholder", trans.writeMsgHere);
    podVerify.querySelector("h3 span").textContent = trans.unverifiedPods;
    podVerify.querySelector(".empty span").textContent =
      trans.noPodVerifications;
    podVerified.querySelector("h3 span").textContent = trans.recentVerifiedPods;
    podVerified.querySelector(".empty span").textContent = trans.noRecentPods;
    $(".admin-info").text(trans.adminInfo);
    $(".l-admin-id").text(trans.adminId + ": ");
    $(".admin-info").text(trans.adminInfo);
    $(".x-name").text(trans.name);
    $(".req-date").text(trans.requestDate);
    $(".btn-msg").text(trans.sendMsg);
    $(".btn-remove").text(trans.remove);
    $(".btn-approve").text(trans.approve);
    $(".btn-update").text(trans.update);
    $(".x-email").text(trans.email);
    $(".ph-email").attr("placeholder", trans.email);
    $(".ph-name").attr("placeholder", trans.name);
    $(".l-podId").text(trans.podId + ": ");
    podInfo.querySelector("h3 span").textContent = trans.podcastInfo;
    $(".x-title").text(trans.title);
    $(".ph-title").attr("placeholder", trans.title);
    $(".ph-desc").attr("placeholder", trans.description);
    $(".l-desc").text(trans.description + ": ");
    $(".x-audio-test").text(trans.audioWorking);
    aFeedUrl.textContent = trans.visitStream;
    $(".x-test").text(trans.test);
    lblPodTestUrl.textContent = trans.testNewStream;
    inFeed.placeholder = trans.feedURL;
    lblPodFeed.textContent = trans.feedURL;
    $(".x-genre").text(trans.genre);
    $(".ph-genre").attr("placeholder", trans.genre);
    $(".x-lang").text(trans.lang);
    $(".ph-lang").attr("placeholder", trans.lang);
    $(".x-country").text(trans.country);
    $(".ph-country").attr("placeholder", trans.country);
    podOptionalInfo.querySelector("h3 span").textContent = trans.optionalInfo;
    $(".x-web").text(trans.webPage);
    $(".ph-web").text(trans.webPage);
    $(".x-visitWeb").text(trans.visitWeb);
    $(".x-phone").text(trans.phone_no);
    $(".ph-phone").attr("placeholder", trans.phone_no);
    $(".ph-fbLink").attr("placeholder", trans.fbLink);
    $(".ph-twLink").attr("placeholder", trans.twLink);
    $(".ph-inLink").attr("placeholder", trans.inLink);
    $(".ph-ytLink").attr("placeholder", trans.ytLink);
    $(".ph-tkLink").attr("placeholder", trans.tkLink);
    $(".ph-ph-addWelcome").attr("placeholder", trans.addWelcomeMsg);
    $(".l-welcomeMsg").text(trans.welcomeMsg);
    $(".x-selReason").text(trans.selectReason);
    $(".x-invalInfo").text(trans.r1);
    $("#podRad2").text(trans.invalidFeed);
    $(".x-polVio").text(trans.r3);
    $(".x-other").text(trans.other);
    $(".ph-writeMsg").attr("placeholder", trans.writeMsgHere);
    $(".x-continue").text(trans.continue);
    $(".x-host").text(trans.host);
    divProducts.querySelector("h3 span").textContent = trans.products;
    divProducts.querySelector(".empty span").textContent = trans.noProducts;
    coinFrag.querySelector("h4 span").textContent = trans.coins;
    var coinGridList = coinFrag.querySelectorAll(".grid-3 p");
    coinGridList[0].textContent = trans.value;
    coinGridList[1].textContent = trans.id;
    coinGridList[2].textContent = trans.cost;
    btnAddProduct.textContent = trans.addCoinPack;
    btnAddCoinPack.textContent = trans.addCoinPack;
    divCoinPack.querySelector("h3 span").textContent = trans.coinPack;
    withdrawals.querySelector("h3 span").textContent = trans.wdRequests;
    wds.querySelector(".empty span").textContent = trans.noWds;
    wdInfoFrag.querySelector("h3 span").textContent = trans.wdRequestInfo;
    divWdReqInfo.querySelector(".wdDate span").textContent = trans.date;
    var wdLabels = divWdUser.querySelectorAll("label");
    wdLabels[0].textContent = trans.name;
    wdLabels[1].textContent = trans.reqAmount;
    wdLabels[2].textContent = trans.initBal;
    wdLabels[3].textContent = trans.payMethod;
    btnWdApprove.textContent = trans.approve;
    btnWdDecline.textContent = trans.decline;
    var btnGoWdRequests = document.getElementById("btnGoWdRequests");
    btnGoWdRequests.querySelector("span").textContent = trans.wdRequests;
    var btnGoProd = document.getElementById("btnGoProd");
    btnGoProd.querySelector("span").textContent = trans.products;
    $(".tc-sel-reason").text(trans.selectReason);
    $(".tc-continue").text(trans.continue);
    var lReasons = wdDeclineDialog.querySelectorAll("label");
    lReasons[0].textContent = trans.wdR1;
    lReasons[1].textContent = trans.wdR2;
    lReasons[2].textContent = trans.other;
    spNotFound.textContent = trans.notFound;
    pResultLoader.querySelector("span").textContent = trans.searchWait;
    btnRadioRevision.querySelector("span").textContent = trans.markRevision;
    $(".btnEdit span").text(trans.edit);
    $(".btnRemove span").text(trans.remove);
    $(".btnEdit").attr("title", trans.edit);
    $(".btnRemove").attr("title", trans.remove);
  }
}
